/* ============================================================
   ACADEMY — Recipe Library · LAYER'D Cakes
   Static asset: upload once to the theme's assets/ folder.

   Two islands, two gates (2026-07-09 restructure):
     #arcp-lib   (premium: Pro OR Academy) — categories + the shared
                 ingredient vocabulary + studio count. Zero recipe IP.
     #arcp-data  (academy-member ONLY) — the studio recipes.
   Shopify renders each island server-side in its own branch —
   fetched on its own, this file has nothing to show anyone.
   A Pro member gets the "My recipes" builder (vocabulary-backed,
   so their recipes sum correctly in the Planner's shopping list);
   the studio browse UI renders only when the recipes island exists.

   Rescale-to-my-pans uses the same pan-area math and smart
   rounding as the Batch Math pan-scaler, so a recipe scaled
   here and a recipe scaled there always agree.
   ============================================================ */
(function () {
  'use strict';
  /* every viewport move routes through the ONE shared utility
     (nav rule 2026-07-20); absent = no scroll, never a local fallback */
  function ldNav(target, opts) {
    var C2 = window.LAYERD && window.LAYERD.components;
    return !!(C2 && C2.navigateToSection && C2.navigateToSection(target, opts));
  }


  var libEl = document.getElementById('arcp-lib');
  var dataEl = document.getElementById('arcp-data');
  var mount = document.getElementById('arcp-app');
  if (!mount || (!libEl && !dataEl)) return;
  var LIB = null, DATA = null;
  try { LIB = libEl ? JSON.parse(libEl.textContent) : null; } catch (e) { LIB = null; }
  try { DATA = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) { DATA = null; }
  if (DATA && (!DATA.categories || !DATA.recipes)) DATA = null;
  var IS_ACADEMY = !!DATA;
  /* categories: from the lib island; legacy fallback to the recipes
     island so an old template + new JS still renders. */
  var CATS = (LIB && LIB.categories) || (DATA && DATA.categories) || [];
  var VOCAB = (LIB && LIB.ingredients) || [];

  /* r177: the free sample ships as a TRIMMED structured island to every
     tier (identity, costing inputs and method - never the cross-references
     into the locked library). Hoisted to module scope in r182 so the
     library accordion can list it, not only the picker. */
  var SAMPLES = (function () {
    try {
      var n = document.getElementById('arcp-samples');
      var a = n ? JSON.parse(n.textContent) : [];
      return Object.prototype.toString.call(a) === '[object Array]' ? a : [];
    } catch (e) { return []; }
  })();
  /* 2026-09-17 (Mariya: "recipes page from the toolkit spine comes up blank").
     The live page had an EMPTY #arcp-lib island: the template SOURCE (with
     its {{LIB_DATA}} placeholders) had been pasted into Shopify instead of
     the generated dist, so Liquid rendered the placeholders as nothing and
     this guard exited with a blank page. Say so on screen instead. */
  if (!CATS.length) {
    var oops = document.createElement('p');
    oops.className = 'learn-panel arcp-noscript';
    oops.textContent = 'the recipe library did not load its data. if you just updated the theme, paste dist/page.academy-recipes.liquid (the generated file), not the template source.';
    mount.appendChild(oops);
    return;
  }

  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'html') n.innerHTML = attrs[k];
      else if (k === 'class') n.className = attrs[k];
      else if (k.slice(0, 2) === 'on') n.addEventListener(k.slice(2), attrs[k]);
      else n.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }
  function clearNode(n) { while (n.firstChild) n.removeChild(n.firstChild); }

  var catById = {};
  CATS.forEach(function (c) { catById[c.id] = c; });

  /* ---------- units: inches ↔ cm (same key as every Learn tool) ----------
     cm is a LABEL over the standard retail metric sizes; the math and the
     stored pan values stay in inches. */
  var UNITS_KEY = 'layerd-learn-units';
  var IN2CM = { 4: 10, 5: 13, 6: 15, 7: 18, 8: 20, 9: 23, 10: 25, 11: 28, 12: 30, 13: 33, 14: 35, 15: 38, 16: 40 };
  function unitPref() {
    try { return localStorage.getItem(UNITS_KEY) === 'cm' ? 'cm' : 'in'; } catch (e) { return 'in'; }
  }
  function sizeLabel(n) {
    return unitPref() === 'cm' ? (IN2CM[n] || Math.round(n * 2.54)) + ' cm' : n + '"';
  }
  var recipeByTitle = {};
  if (DATA) DATA.recipes.forEach(function (r) {
    if (!r.variation) recipeByTitle[r.title.toLowerCase()] = r.id;
  });

  /* ---------- scaling (mirrors Batch Math tool 3) ---------- */
  function panArea(p) { return p.shape === 'square' ? p.d * p.d : Math.PI * p.d * p.d / 4; }
  function smartRound(v) {
    if (v >= 100) return Math.round(v / 5) * 5;
    if (v >= 10) return Math.round(v);
    if (v >= 1) return Math.round(v * 2) / 2;
    return Math.round(v * 100) / 100;
  }
  function fmtNum(n) {
    if (n >= 1000) return Math.round(n).toLocaleString('en-CA');
    if (n === Math.round(n)) return String(n);
    return String(Math.round(n * 100) / 100);
  }
  function isEgg(ing) { return !ing.unit && /\begg/i.test(ing.item); }
  function isLeavener(ing) { return /baking\s*powder|baking\s*soda|bicarbonate|bicarb/i.test(ing.item); }

  function ingLine(ing, factor) {
    var flags = [];
    if (ing.qty == null) {
      return { text: ing.item + (ing.note ? ' · ' + ing.note : ''), flags: flags, unscaled: factor !== 1 };
    }
    var v = ing.qty * factor;
    if (factor !== 1) {
      if (isEgg(ing)) {
        v = Math.max(0.5, Math.round(v * 2) / 2);
        if (v !== Math.round(v)) flags.push('halfEgg');
      } else {
        v = smartRound(v);
      }
      if (isLeavener(ing) && (factor >= 2 || factor <= 0.5)) flags.push('leavener');
    }
    var text = fmtNum(v) + (ing.unit ? ' ' + ing.unit : '') + ' ' + ing.item;
    if (ing.note) text += ' · ' + ing.note;
    return { text: text, flags: flags };
  }

  /* Two-column split of one ingredient at a scale factor: the name on the
     left, the amount (qty + unit) on the right as a tabular column. Shared
     by fillIngs; ingLine() above still produces the single-string form used
     by copy/plan handoff, so the two never drift. */
  function ingParts(ing, factor) {
    var flags = [];
    var name = ing.item + (ing.note ? ' · ' + ing.note : '');
    if (ing.qty == null) return { name: name, amount: '', flags: flags };
    var v = ing.qty * factor;
    if (factor !== 1) {
      if (isEgg(ing)) {
        v = Math.max(0.5, Math.round(v * 2) / 2);
        if (v !== Math.round(v)) flags.push('halfEgg');
      } else {
        v = smartRound(v);
      }
      if (isLeavener(ing) && (factor >= 2 || factor <= 0.5)) flags.push('leavener');
    }
    return { name: name, amount: fmtNum(v) + (ing.unit ? ' ' + ing.unit : ''), flags: flags };
  }

  /* Baker's-percent base: the first flour line weighed in grams. The
     Studio Book detail shows a quiet % column beside gram amounts —
     only where a recipe actually has a gram-weighed flour to anchor it
     (crémeux, curds and syrups have no meaningful baker's %). */
  function pctBaseOf(r) {
    for (var i = 0; i < r.ingredients.length; i++) {
      var ing = r.ingredients[i];
      if (ing.qty != null && (ing.unit || '') === 'g' && /flour/i.test(ing.item)) return ing.qty;
    }
    return null;
  }

  /* Fill an ingredient list + caution box for a recipe at a scale factor.
     Shared by the studio cards and the "My recipes" cards so egg/leavener
     handling is identical everywhere. Each row is name (left) · faint
     baker's % where it applies · amount (right, serif) over a hairline. */
  function fillIngs(r, factor, ingList, cautionBox) {
    clearNode(ingList);
    clearNode(cautionBox);
    var hadHalf = false, hadLeaven = false;
    var pctBase = pctBaseOf(r);
    r.ingredients.forEach(function (ing) {
      var p = ingParts(ing, factor);
      var isLeaven = p.flags.indexOf('leavener') !== -1;
      if (p.flags.indexOf('halfEgg') !== -1) hadHalf = true;
      if (isLeaven) hadLeaven = true;
      /* the % never scales — it is a ratio, so it holds at every factor */
      var pct = (pctBase && ing.qty != null && (ing.unit || '') === 'g')
        ? Math.round(ing.qty / pctBase * 100) + '%' : '';
      ingList.appendChild(el('li', { class: 'arcp-ing' + (isLeaven ? ' is-caution' : '') }, [
        el('span', { class: 'arcp-ing__name', text: p.name }),
        el('span', { class: 'arcp-ing__pct', 'aria-hidden': 'true', text: pct }),
        el('span', { class: 'arcp-ing__amount', text: p.amount + (isLeaven ? ' ⚠' : '') })
      ]));
    });
    if (hadHalf) {
      cautionBox.appendChild(el('p', { class: 'arcp-note', text:
        'Half an egg is real: whisk one egg and use half of it by weight (about 25 g).' }));
    }
    if (hadLeaven) {
      cautionBox.appendChild(el('div', { class: 'learn-tip arcp-caution' }, [
        el('span', { class: 'learn-tip__label', text: 'Caution' }),
        el('span', { text: 'Leaveners stop scaling in a straight line much past 2×, or below half. Start a touch under the number and let a test layer be the judge.' })
      ]));
    }
  }

  /* ---------- send to the Batch Math day plan ----------
     Writes into the SAME localStorage store the Batch Math premium
     day planner reads (layerd-batch-math-saved, type 'sc'), so a
     recipe saved here appears under "Bake first" on the Batch Math
     page's Saved recipes & day plan section. Academy members are
     premium there by definition (either tag opens it).
     Pan recipes hand over their pan basis + the chosen pans, so the
     planner recomputes the factor itself; batch-scaled recipes hand
     over already-scaled lines at factor 1. */
  var PLAN_KEY = 'layerd-batch-math-saved';

  function ingText(ing, f) {
    if (ing.qty == null) return ing.item + (ing.note ? ' - ' + ing.note : '');
    var v = ing.qty * f;
    if (f !== 1) v = isEgg(ing) ? Math.max(0.5, Math.round(v * 2) / 2) : smartRound(v);
    return fmtNum(v) + (ing.unit ? ' ' + ing.unit : '') + ' ' + ing.item +
      (ing.note ? ' - ' + ing.note : '');
  }

  function addToPlan(r, factor, pb, sel) {
    var store;
    try { store = JSON.parse(localStorage.getItem(PLAN_KEY)); } catch (e) { store = null; }
    if (!store || store.v !== 1 || Object.prototype.toString.call(store.items) !== '[object Array]') {
      store = { v: 1, items: [] };
    }
    if (store.items.length >= 30) return 'full';
    var name = r.title + (r.variation ? ' · ' + r.variation : '');
    var data;
    if (pb) {
      data = {
        src: { d: pb.d, shape: pb.shape, layers: pb.layers },
        tgt: { d: sel.d, shape: sel.shape, layers: sel.layers },
        text: r.ingredients.map(function (ing) { return ingText(ing, 1); }).join('\n')
      };
    } else {
      if (factor !== 1) name += ' ×' + factor;
      var pan = { d: 8, shape: 'round', layers: 2 };
      data = {
        src: pan, tgt: pan,
        text: r.ingredients.map(function (ing) { return ingText(ing, factor); }).join('\n')
      };
    }
    store.items.push({
      id: Date.now().toString(36) + Math.random().toString(36).slice(2, 6),
      t: 'sc', name: name, on: true, at: Date.now(), data: data
    });
    try { localStorage.setItem(PLAN_KEY, JSON.stringify(store)); } catch (e) { return 'error'; }
    return 'ok';
  }

  /* ---------- copy ---------- */
  function copyText(r, factor) {
    var lines = ["LAYER'D Cakes Academy - " + r.title + (r.variation ? ' (' + r.variation + ')' : '')];
    if (factor !== 1) lines.push('Scaled x' + (Math.round(factor * 100) / 100) + ' for your pans');
    if (r.yieldNote) lines.push('Yield: ' + r.yieldNote + (factor !== 1 ? ' (before scaling)' : ''));
    lines.push('', 'INGREDIENTS');
    r.ingredients.forEach(function (ing) { lines.push('- ' + ingLine(ing, factor).text); });
    if (r.method && r.method.length) {
      lines.push('', 'METHOD');
      r.method.forEach(function (s, i) { lines.push((i + 1) + '. ' + s); });
    }
    if (r.tips && r.tips.length) {
      lines.push('', 'NOTES');
      r.tips.forEach(function (t) { lines.push('- ' + t); });
    }
    if (r.storage) lines.push('', 'STORAGE: ' + r.storage);
    return lines.join('\n');
  }

  /* ---------- pan sizes for the open-recipe rescaler ---------- */
  var DIAMETERS = [];
  for (var d = 4; d <= 16; d++) DIAMETERS.push(d);

  /* "Add to [client]'s components" — the library-to-file bridge for a single
     recipe: one Components row (batches editable in the Planner). */
  function clientAddBtn(r) {
    var b = (window.LdCakeFile && window.LdCakeFile.getActiveBooking) ? window.LdCakeFile.getActiveBooking() : null;
    if (!b) return null;
    var name = (b.name || '').trim() || 'the client';
    var btn = el('button', { class: 'ld-btn ld-btn--secondary arcp-addclient', type: 'button',
      text: 'Add to ' + name + '\u2019s components' });
    btn.addEventListener('click', function () {
      var mineFlag = false;
      try { mineFlag = readMine().items.some(function (m) { return m.id === r.id; }); } catch (e) { }
      var store = window.LdCakeFile.readStore(); var ok = false;
      for (var i = 0; i < store.bookings.length; i++) {
        var bk = store.bookings[i];
        if (bk.id !== b.id) continue;
        bk.components = bk.components || [];
        bk.components.push({ name: r.title, category: r.category || 'bases',
          recipeId: mineFlag ? 'mine:' + r.id : r.id, batches: 1 });
        ok = true;
      }
      if (ok) { try { localStorage.setItem('layerd-academy-bookings', JSON.stringify(store)); } catch (e) { ok = false; } }
      if (ok) {
        try { window.dispatchEvent(new CustomEvent('layerd:cakefile', { detail: { type: 'file', source: 'recipes' } })); } catch (e) { }
        try { window.dispatchEvent(new Event('layerd:cake-updated')); } catch (e) { }
        btn.textContent = 'Added to ' + name + ' \u2713';
        btn.disabled = true;
      }
    });
    return btn;
  }

  /* ---------- search + scope (r182, "Combos on top") ----------
     The chip rail and the second full copy of the studio library are both
     gone. ONE accordion renders whichever scope is showing; search filters
     it live (matching categories auto-expand, the rest collapse and hide)
     and clearing the field restores what was open before. ---------- */
  var filter = { q: '' };
  var scope = 'mine';                 /* 'mine' | 'studio' */
  /* Session-persisted expansion: the design asks for all-collapsed on a
     first visit and the last state restored on return within the session. */
  var EXP_KEY = 'layerd-arcp-expanded';
  var expanded = (function () {
    try {
      var v = JSON.parse(sessionStorage.getItem(EXP_KEY));
      return (v && typeof v === 'object') ? v : {};
    } catch (e) { return {}; }
  })();
  function saveExpanded() {
    try { sessionStorage.setItem(EXP_KEY, JSON.stringify(expanded)); } catch (e) { }
  }
  /* what search hid/opened is NOT the baker's choice — remember hers and
     put it back the moment the field is empty again */
  var preSearchExpanded = null;
  function matches(r) {
    if (!filter.q) return true;
    var hay = (r.title + ' ' + (r.variation || '') + ' ' + (r.intro || '') + ' ' +
      (r.ingredients || []).map(function (i) { return i.item; }).join(' ')).toLowerCase();
    return hay.indexOf(filter.q) !== -1;
  }

  var search = el('input', {
    class: 'arcp-search', type: 'search',
    placeholder: 'Search recipes', 'aria-label': 'Search recipes'
  });
  search.addEventListener('input', function () {
    var was = filter.q;
    filter.q = search.value.trim().toLowerCase();
    if (!was && filter.q) preSearchExpanded = JSON.parse(JSON.stringify(expanded));
    if (was && !filter.q && preSearchExpanded) { expanded = preSearchExpanded; preSearchExpanded = null; saveExpanded(); }
    renderLibrary();
  });

  /* ============================================================
     MY RECIPES — students add their own
     Stored per-browser in localStorage (layerd-academy-my-recipes),
     capped at MINE_MAX. Each saved recipe scales, copies, and — the
     point of the feature — hands off to the Batch Math production
     day planner via the same addToPlan() bridge the studio recipes
     use, so a student's own recipe joins their make schedule and
     shopping list. Nothing here is ever uploaded.
     ============================================================ */
  var MINE_KEY = 'layerd-academy-my-recipes';
  /* r53 (Mariya, 2026-08-19): the recipe box opens to EVERYONE — free and
     logged-out included — capped at three recipes below Pro. Three of
     their own recipes riding into the Planner, Batch Math and the
     shopping list is the demo that sells the tool; the studio recipes
     stay Academy-only (server-side, the leak check enforces it).
     The cap gates ADDING, never reading: a lapsed Pro with forty saved
     recipes keeps all forty usable — they just can't add a forty-first.
     Pro keeps 100 (Toolkit Fix 02: a working studio blows past 20). */
  var MINE_PRO = (function () {
    if (typeof IS_ACADEMY !== 'undefined' && IS_ACADEMY) return true;
    var host = document.querySelector('[data-lh-tier]');
    return !!(host && host.getAttribute('data-lh-tier') === 'premium');
  })();
  var MINE_MAX = MINE_PRO ? 100 : 3;

  function readMine() {
    try {
      var v = JSON.parse(localStorage.getItem(MINE_KEY));
      if (v && v.v === 1 && Object.prototype.toString.call(v.items) === '[object Array]') return v;
    } catch (e) { /* private mode / corrupt — start fresh */ }
    return { v: 1, items: [] };
  }
  function writeMine() {
    try { localStorage.setItem(MINE_KEY, JSON.stringify(mine)); return true; }
    catch (e) { return false; }
  }
  var mine = readMine();
  function mineId() { return 'my' + Date.now().toString(36) + Math.random().toString(36).slice(2, 5); }

  var mineListWrap, mineOpenWrap;
  /* 2026-08-07 prototype-layout pass (RecipesScreen structure): the studio
     recipes render in their own gold-bordered card under a ✦ section head,
     and the empty recipe box reads as a dashed invite. Markup only — the
     data, quotas and handlers are untouched. */
  /* the recipe currently open in the editor; the delete paths read it */
  var editingId = null;

  /* ---------- the shared ingredient vocabulary ----------
     Same list the studio recipes use (names + canonical units). When a
     student picks a vocabulary name AND the unit agrees with the
     canonical one, the line stores an ingredientId — so in the Planner's
     shopping list their flour and the studio's flour sum into ONE line,
     grouped by aisle, with pack hints. Free-typed ingredients still
     save fine; they just group under "Everything else" and only merge
     with identically-spelled lines. */
  var VOCAB_LIST_ID = 'arcp-ingvocab';
  function buildVocabDatalist() {
    if (!VOCAB.length || document.getElementById(VOCAB_LIST_ID)) return null;
    var dl = el('datalist', { id: VOCAB_LIST_ID });
    VOCAB.forEach(function (v) { dl.appendChild(el('option', { value: v.name })); });
    return dl;
  }

  /* ============================================================
     ADD A RECIPE — r184 "Paste, then confirm"
     Her second handoff (design_handoff_add_recipe). The old form asked
     for an instruction paragraph, a six-pill component cloud and a
     four-column Qty|Unit|Ingredient|▾ grid, 28 rows deep for the big
     chocolate cake, with paste buried at the bottom as a text link.

     This inverts it: PASTING IS THE FRONT DOOR and the editor arrives
     pre-filled for confirmation. Typing is one of the doors, not the
     only one.

     Two screens: the entry chooser, then one editor. The editor is
     shared — a pasted recipe opens it with its rows collapsed and
     match-checked, "Type it out" opens it with one row already open,
     and Edit opens it on a saved recipe. One row component, two default
     expansion states, so the two can never drift.
     ============================================================ */

  /* ---------- the parser ----------
     A pure function on purpose: parseRecipe(text) -> draft. Nothing in
     here touches the DOM or the store, so it can be checked against a
     real paste in the console (window.LAYERD.parseRecipe).

     Rule zero, from the handoff: NEVER FAIL SILENTLY. Fewer than two
     ingredient lines and the caller opens the manual editor with the raw
     text preserved, so a bad parse costs a retype, never the paste. */
  var UNIT_WORDS = {
    g: 'g', gram: 'g', grams: 'g', gr: 'g',
    kg: 'kg', kilo: 'kg', kilos: 'kg', kilogram: 'kg', kilograms: 'kg',
    mg: 'mg', ml: 'ml', millilitre: 'ml', milliliter: 'ml',
    l: 'l', litre: 'l', liter: 'l', litres: 'l', liters: 'l',
    oz: 'oz', ounce: 'oz', ounces: 'oz',
    lb: 'lb', lbs: 'lb', pound: 'lb', pounds: 'lb',
    tsp: 'tsp', tsps: 'tsp', teaspoon: 'tsp', teaspoons: 'tsp',
    tbsp: 'tbsp', tbsps: 'tbsp', tablespoon: 'tbsp', tablespoons: 'tbsp',
    cup: 'cup', cups: 'cup',
    pinch: 'pinch', stick: 'stick', sticks: 'stick',
    sheet: 'sheets', sheets: 'sheets',
    can: 'can', cans: 'can'
  };
  var UNI_FRAC = { '½': 0.5, '⅓': 1 / 3, '⅔': 2 / 3, '¼': 0.25, '¾': 0.75,
    '⅕': 0.2, '⅖': 0.4, '⅗': 0.6, '⅘': 0.8, '⅙': 1 / 6, '⅚': 5 / 6,
    '⅛': 0.125, '⅜': 0.375, '⅝': 0.625, '⅞': 0.875 };
  var HEADINGS = /^(ingredients?|method|instructions?|directions?|steps?|preparation|yield|makes)\b/i;
  var MODE_ING = /^(ingredients?)\b/i;
  var MODE_METHOD = /^(method|instructions?|directions?|steps?|preparation)\b/i;
  var CAT_KEYWORDS = [
    ['cremeux', /cr[ée]meux|ganache/i],
    ['montees', /mont[ée]e|whipped|mousse|namelaka|diplomat/i],
    ['jellies', /jell(y|ies)|compote|curd|caramel|jam|coulis|confit/i],
    ['finishes', /buttercream|smbc|imbc|meringue|glaze|icing|frosting|ganache glaze/i],
    ['bases', /cake|sponge|g[ée]noise|chiffon|joconde|dacquoise|biscuit|brownie/i]
  ];

  function fracToNumber(s) {
    s = String(s).trim();
    var uni = 0, m;
    /* "1 ½" and a bare "½" both land here */
    for (var ch in UNI_FRAC) {
      if (Object.prototype.hasOwnProperty.call(UNI_FRAC, ch) && s.indexOf(ch) > -1) {
        uni = UNI_FRAC[ch];
        s = s.replace(ch, '').trim();
      }
    }
    if (!s) return uni || null;
    m = s.match(/^(\d+)\s+(\d+)\/(\d+)$/);
    if (m) return +m[1] + (+m[2]) / (+m[3]) + uni;
    m = s.match(/^(\d+)\/(\d+)$/);
    if (m) return (+m[1]) / (+m[2]) + uni;
    var n = parseFloat(s.replace(',', '.'));
    return isFinite(n) ? n + uni : (uni || null);
  }
  /* a leading quantity, with the range kept verbatim for the note */
  function leadQty(line) {
    var m = line.match(/^((?:\d+[.,]?\d*|[½⅓⅔¼¾⅕⅖⅗⅘⅙⅚⅛⅜⅝⅞])(?:\s*\d+\/\d+)?(?:\s*[½⅓⅔¼¾⅕⅖⅗⅘⅙⅚⅛⅜⅝⅞])?)\s*(?:[-–—]|to)\s*(\d+[.,]?\d*)\s*(.*)$/i);
    if (m) {
      return { qty: fracToNumber(m[1]), rest: m[3] || '',
        note: m[1] + '–' + m[2] + ' in the original' };
    }
    m = line.match(/^((?:\d+[.,]?\d*)?(?:\s*\d+\/\d+)?(?:\s*[½⅓⅔¼¾⅕⅖⅗⅘⅙⅚⅛⅜⅝⅞])?)\s*(.*)$/);
    if (!m || !m[1].trim()) return null;
    var q = fracToNumber(m[1]);
    if (q == null || !isFinite(q)) return null;
    return { qty: q, rest: m[2] || '', note: '' };
  }
  function looksLikeIngredient(line) {
    return !!leadQty(line.replace(/^[-*•·\s]+/, ''));
  }
  function parseIngredientLine(raw) {
    var line = String(raw || '').replace(/^[-*•·\s]+/, '').trim().replace(/\.$/, '');
    if (!line) return null;
    var out = { item: '', note: '' };
    var lead = leadQty(line);
    var rest = line;
    if (lead) {
      out.qty = lead.qty;
      if (lead.note) out.note = lead.note;
      rest = lead.rest;
    }
    /* the unit word, normalised to the vocabulary's canonical spelling.
       "3 egg yolks" is a COUNT, not a unit — the word stays in the item. */
    var w = rest.match(/^([A-Za-z%]+)\.?\s+(.*)$/);
    if (w) {
      var u = UNIT_WORDS[w[1].toLowerCase()];
      if (u) { out.unit = u; rest = (w[2] || '').trim(); }
    } else if (/^%\s*/.test(rest)) {
      /* "35% cream" is a description, never a unit */
    }
    /* a parenthetical straight after the quantity is a conversion or an
       aside - "(140 g)", "(room temperature)" - not part of the name.
       Live Text pastes are full of these; left in the item they break
       the vocabulary match, so they move to the note. */
    var par = rest.match(/^\(([^)]{1,40})\)\s*(.+)$/);
    if (par) {
      out.note = out.note ? out.note + ' \u00b7 ' + par[1].trim() : par[1].trim();
      rest = par[2];
    }
    /* anything after a comma is the line note ("softened", "room temp") */
    var c = rest.indexOf(',');
    if (c > -1) {
      var tail = rest.slice(c + 1).trim();
      rest = rest.slice(0, c).trim();
      if (tail) out.note = out.note ? out.note + ' · ' + tail : tail;
    }
    out.item = rest.trim();
    if (!out.item) {
      /* "350 g" with nothing after it is not an ingredient */
      if (out.unit) { out.item = out.unit; delete out.unit; }
      else return null;
    }
    out.item = out.item.charAt(0).toUpperCase() + out.item.slice(1);
    if (!out.note) delete out.note;
    return out;
  }
  /* "Makes about 935 g" / "Yield: two 6-inch layers" */
  function parseYieldLine(line) {
    var m = String(line).match(/^(?:makes|yields?|yield)\s*:?\s*(.+)$/i);
    if (!m) return null;
    var note = m[1].trim().replace(/\.$/, '');
    var g = note.match(/(\d[\d.,]*)\s*(g|grams?|kg)\b/i);
    var out = { yieldNote: note.charAt(0).toUpperCase() + note.slice(1) };
    if (g) {
      var n = parseFloat(g[1].replace(/,/g, ''));
      if (isFinite(n) && n > 0) out.yieldG = /kg/i.test(g[2]) ? n * 1000 : n;
    }
    return out;
  }
  function detectCategory(title) {
    for (var i = 0; i < CAT_KEYWORDS.length; i++) {
      if (CAT_KEYWORDS[i][1].test(title || '')) {
        /* only offer a category this library actually has */
        if (catById[CAT_KEYWORDS[i][0]]) return CAT_KEYWORDS[i][0];
      }
    }
    return catById.other ? 'other' : (CATS[0] && CATS[0].id) || 'other';
  }
  function parseRecipe(text) {
    var lines = String(text || '').split(/\r?\n/)
      .map(function (l) { return l.trim(); })
      .filter(function (l) { return l && !/^[^\wÀ-ɏ]+$/.test(l); });
    var draft = { title: '', category: '', ingredients: [], method: [] };
    var mode = null, sawHeading = false, lastIngIdx = -1;
    var body = [];
    lines.forEach(function (l) {
      if (MODE_ING.test(l) && l.length < 24) { mode = 'ing'; sawHeading = true; return; }
      if (MODE_METHOD.test(l) && l.length < 24) { mode = 'method'; sawHeading = true; return; }
      var y = parseYieldLine(l);
      if (y && !draft.yieldNote) {
        draft.yieldNote = y.yieldNote;
        if (y.yieldG) draft.yieldG = y.yieldG;
        return;
      }
      /* r187: recipe-site pastes lead with time metadata - "prepare: 1h10
         min", "Cook: 14 min", "Refrigerate: 12 h". Left alone they became
         junk NEW-ingredient rows. The shape is unmistakable (one of these
         words, a colon, digits), so they are dropped - and ONLY this
         shape, because a real ingredient never looks like it. */
      if (/^(prep(?:are)?|cook(?:ing)?|bake|baking|total|active|chill(?:ing)?|rest(?:ing)?|refrigerate|freeze|serves|servings|difficulty)\s*(?:time)?\s*[:\-]\s*\d/i.test(l)) return;
      if (!draft.title && !HEADINGS.test(l) && !looksLikeIngredient(l)) { draft.title = l; return; }
      body.push({ text: l, mode: mode });
    });
    if (sawHeading) {
      body.forEach(function (b) {
        if (b.mode === 'method') { draft.method.push(stripStepNumber(b.text)); return; }
        var ing = parseIngredientLine(b.text);
        if (ing) draft.ingredients.push(ing);
        else if (b.mode === 'ing') draft.ingredients.push({ item: b.text });
        else draft.method.push(stripStepNumber(b.text));
      });
    } else {
      /* no headings: a line that starts with a quantity is an ingredient,
         and EVERYTHING AFTER THE LAST such line is method */
      for (var i = 0; i < body.length; i++) if (looksLikeIngredient(body[i].text)) lastIngIdx = i;
      body.forEach(function (b, i) {
        if (i <= lastIngIdx) {
          var ing = parseIngredientLine(b.text);
          if (ing) draft.ingredients.push(ing);
          else draft.method.push(stripStepNumber(b.text));
        } else {
          draft.method.push(stripStepNumber(b.text));
        }
      });
    }
    draft.title = draft.title || '';
    /* r189 (Mariya): "this should default to blank and not allow a user
       to save until they select something, so that things are not
       accidentally saved under the wrong section." The keyword guess is
       gone from the draft - HER OWN Salted Caramel once filed itself
       under the wrong section by exactly this kind of guess (the
       bases-never-sync bug), and a blank the baker must fill is the only
       default that cannot be wrong. detectCategory() itself stays for
       console testing, but nothing downstream reads it any more. */
    draft.category = '';
    draft.ingredients.forEach(matchIngredient);
    return draft;
  }
  /* r187 (Mariya's iPhone test): text copied out of the camera roll via
     Live Text can land on the clipboard URL-ENCODED - her paste read
     "prepare:%201h10%20min%0ACook%3A..." and parsed as one garbage line.
     If the text is dense with %XX escapes and includes encoded spaces or
     newlines, decode it before parsing; anything malformed falls back to
     the raw text untouched (decodeURIComponent throws, never mangles). */
  function maybeDecode(text) {
    var s = String(text || '');
    var hits = (s.match(/%[0-9A-Fa-f]{2}/g) || []).length;
    if (hits >= 3 && /%(?:20|0A|0D)/.test(s)) {
      try { return decodeURIComponent(s); } catch (e) { /* not encoding after all */ }
    }
    return s;
  }
  function stripStepNumber(s) {
    return String(s).replace(/^\s*(?:step\s*)?\d+\s*[.)\-:]\s*/i, '').trim();
  }
  /* singular/plural tolerant, case-insensitive match into ingredients.json.
     A hit sets ingredientId, which is what makes her flour and the
     studio's flour sum into ONE line in the Planner's shopping list. */
  function normName(s) {
    return String(s || '').toLowerCase().trim()
      .replace(/[^\w\s%À-ɏ]/g, '')
      .replace(/\s+/g, ' ')
      .replace(/s$/, '');
  }
  var vocabByNorm = {};
  VOCAB.forEach(function (v) { vocabByNorm[normName(v.name)] = v; });
  function matchIngredient(ing) {
    var v = vocabByNorm[normName(ing.item)];
    delete ing.ingredientId;
    if (!v) return ing;
    /* THE UNITS HAVE TO AGREE, and the match NEVER invents one.
       "3 egg yolks" is a count of three; the vocabulary weighs yolks in
       grams. An earlier pass filled the canonical unit in on any bare
       quantity, which quietly turned three yolks into three grams and
       would have summed that into the shopping list. A bare quantity
       against a weighed ingredient is a mismatch, and mismatches are
       exactly what the NEW state is for. */
    var u = (ing.unit || '').toLowerCase();
    var ok;
    if (v.unit === 'count') ok = (u === '' || u === 'count');
    else if (u) ok = (u === String(v.unit).toLowerCase());
    else ok = (ing.qty == null);   /* no quantity = nothing to mis-sum */
    if (ok) ing.ingredientId = v.id;
    return ing;
  }
  /* the closest few vocabulary names, for the NEW row's suggestions */
  function nearVocab(item) {
    var n = normName(item);
    var words = n.split(' ').filter(Boolean);
    return VOCAB.map(function (v) {
      var vn = normName(v.name), score = 0;
      if (vn.indexOf(n) > -1 || n.indexOf(vn) > -1) score += 6;
      words.forEach(function (w) { if (w.length > 2 && vn.indexOf(w) > -1) score += 2; });
      return { v: v, score: score };
    }).filter(function (x) { return x.score > 0; })
      .sort(function (a, b) { return b.score - a.score; })
      .slice(0, 4).map(function (x) { return x.v; });
  }
  try {
    window.LAYERD = window.LAYERD || {};
    window.LAYERD.parseRecipe = parseRecipe;
  } catch (e) { }

  /* ---------- the editor sheet (Screen 2, and the manual door) ----------
     draft is a plain recipe object; opts.mode 'review' opens its rows
     collapsed (confirm a paste), 'manual' opens them expanded (type it
     out). Everything else about the two is identical, which is the point. */
  var editorSheet = null;

  function catLabelShort(id) {
    var c = catById[id];
    return c ? (CAT_SHORT[id] || c.label.split(' · ')[0]) : 'Other';
  }
  /* one small bottom sheet, reused by COMPONENT and MAKES */
  function chooseCategory(current, done) {
    var sh = makeSheet('bottom');
    sh.panel.classList.add('arcp-sheet__panel--menu');
    sh.head.appendChild(el('span', { class: 'arcp-sheet__h2', text: 'Component' }));
    var d = el('button', { class: 'arcp-sheet__done', type: 'button', text: 'Done' });
    d.addEventListener('click', function () { sh.close(); });
    sh.head.appendChild(d);
    CATS.forEach(function (c) {
      var b = el('button', { class: 'arcp-menuitem' + (c.id === current ? ' is-on' : ''), type: 'button' }, [
        el('span', { text: catLabelShort(c.id) }),
        el('span', { class: 'arcp-tick' + (c.id === current ? ' is-on' : ''), 'aria-hidden': 'true' })
      ]);
      b.addEventListener('click', function () { sh.close(); done(c.id); });
      sh.body.appendChild(b);
    });
    sh.open();
  }
  function editYield(draft, done) {
    var sh = makeSheet('bottom');
    sh.panel.classList.add('arcp-sheet__panel--menu');
    sh.head.appendChild(el('span', { class: 'arcp-sheet__h2', text: 'Makes' }));
    var d = el('button', { class: 'arcp-sheet__done', type: 'button', text: 'Done' });
    sh.head.appendChild(d);
    var note = el('input', { class: 'arcp-fld', type: 'text', placeholder: cupsNote(draft) || 'e.g. one 6-inch tier',
      'aria-label': 'Makes' });
    note.value = draft.yieldNote || '';
    var grams = el('input', { class: 'arcp-fld', type: 'number', min: '0', step: '10',
      placeholder: 'e.g. 500', 'aria-label': 'Yield per batch in grams', inputmode: 'decimal' });
    var estG2 = 0;
    (draft.ingredients || []).forEach(function (i) {
      var u = ((i && i.unit) || '').trim().toLowerCase();
      if (i && +i.qty > 0 && (u === 'g' || u === 'ml')) estG2 += +i.qty;
      else if (i && +i.qty > 0 && u === 'kg') estG2 += +i.qty * 1000;
    });
    estG2 = Math.round(estG2 / 10) * 10;
    grams.value = draft.yieldG != null ? String(draft.yieldG) : (estG2 > 0 ? String(estG2) : '');
    sh.body.appendChild(el('div', { class: 'arcp-ysheet' }, [
      el('label', { class: 'arcp-ysheet__f' }, [
        el('span', { class: 'arcp-beyebrow', text: 'MAKES' }), note
      ]),
      el('label', { class: 'arcp-ysheet__f' }, [
        el('span', { class: 'arcp-beyebrow', text: 'GRAMS PER BATCH' }), grams,
        el('span', { class: 'arcp-ysheet__hint',
          text: (estG2 > 0 ? 'Worked out from the ingredient weights (' + estG2.toLocaleString('en-CA') + ' g). Lower it if the recipe cooks down. ' : '') +
            'This is what one batch weighs. Batch Math, the Planner and Pricing turn it into batch counts for each cake.' })
      ])
    ]));
    d.addEventListener('click', function () {
      var n = note.value.trim();
      if (n) draft.yieldNote = n; else delete draft.yieldNote;
      var g = parseFloat(grams.value);
      if (g > 0) { draft.yieldG = g; draft.yieldEst = (estG2 > 0 && g === estG2); } else { delete draft.yieldG; delete draft.yieldEst; }
      sh.close();
      done();
    });
    sh.open();
  }

  function openRecipeEditor(draft, opts) {
    opts = opts || {};
    if (editorSheet) editorSheet.close();
    var mode = opts.mode === 'manual' ? 'manual' : 'review';
    var dirty = !!opts.dirty;
    var sh = makeSheet('full');
    editorSheet = sh;
    sh.panel.classList.add('arcp-sheet__panel--editor');

    /* -- header: Cancel/Back · TITLE · Save -- */
    var leadBtn = el('button', { class: 'arcp-sheet__cancel', type: 'button',
      text: opts.backTo ? 'Back' : 'Cancel' });
    leadBtn.addEventListener('click', function () {
      if (opts.backTo && !dirty) { sh.close(); opts.backTo(); return; }
      if (dirty && !window.confirm('Discard this recipe?')) return;
      sh.close();
      if (opts.backTo) opts.backTo();
    });
    var saveTop = el('button', { class: 'arcp-sheet__act', type: 'button', text: 'Save' });
    saveTop.addEventListener('click', function () { commit(); });
    sh.head.appendChild(leadBtn);
    sh.head.appendChild(el('span', { class: 'arcp-sheet__title',
      text: opts.title || (draft.id ? 'EDIT RECIPE' : 'CHECK & SAVE') }));
    sh.head.appendChild(saveTop);

    /* -- name -- */
    var nameI = el('input', { class: 'arcp-bname', type: 'text', placeholder: 'Pistachio crémeux',
      'aria-label': 'Recipe name' });
    nameI.value = draft.title || '';
    /* r184 had the component follow the name via keyword detection;
       r189 reverses that on Mariya's instruction - a guessed section is
       how recipes get "accidentally saved under the wrong section", so
       the component starts BLANK and only her explicit pick fills it. */
    nameI.addEventListener('input', function () {
      draft.title = nameI.value;
      nameI.classList.remove('is-bad');
      dirty = true; syncSave();
    });

    /* -- component + makes, each a row with its own CHANGE -- */
    var catVal = el('span', { class: 'arcp-ar__val' });
    var catBtn = el('button', { class: 'arcp-changepill', type: 'button', text: 'CHANGE' });
    catBtn.addEventListener('click', function () {
      chooseCategory(draft.category, function (id) {
        draft.category = id; dirty = true; drawHead(); syncSave();
      });
    });
    var yieldVal = el('span', { class: 'arcp-ar__val' });
    var yieldBtn = el('button', { class: 'arcp-changepill', type: 'button' });
    yieldBtn.addEventListener('click', function () {
      editYield(draft, function () { dirty = true; drawHead(); });
    });
    function drawHead() {
      if (draft.category) {
        catVal.textContent = catLabelShort(draft.category);
        catVal.classList.remove('is-ph');
        catBtn.textContent = 'CHANGE';
        catBtn.classList.remove('is-bad');
      } else {
        catVal.textContent = 'Choose one';
        catVal.classList.add('is-ph');
        catBtn.textContent = 'CHOOSE';
      }
      var bits = [];
      if (draft.yieldNote) bits.push(draft.yieldNote);
      else if (draft.yieldG) bits.push(fmtNum(draft.yieldG) + ' g');
      yieldVal.textContent = bits.length ? bits.join(' · ') : 'Not set yet';
      yieldVal.classList.toggle('is-ph', !bits.length);
      yieldBtn.textContent = bits.length ? 'CHANGE' : 'SET';
    }

    /* -- ingredients -- */
    var ingHead = el('span', { class: 'arcp-beyebrow' });
    var ingBox = el('div', { class: 'arcp-arlist' });
    var addIng = el('button', { class: 'arcp-blink', type: 'button', text: '+ Add ingredient' });
    addIng.addEventListener('click', function () {
      draft.ingredients.push({ item: '' });
      dirty = true;
      drawIngs(draft.ingredients.length - 1);
    });

    function drawIngs(openIdx) {
      clearNode(ingBox);
      ingHead.textContent = 'INGREDIENTS · ' + draft.ingredients.length;
      draft.ingredients.forEach(function (ing, i) {
        var open = (mode === 'manual' && openIdx == null) || openIdx === i;
        ingBox.appendChild(open ? ingEditor(ing, i) : ingRow(ing, i));
      });
      syncSave();
    }
    /* collapsed: qty+unit, the item, and whether it matched the vocabulary */
    function ingRow(ing, i) {
      var matched = !!ing.ingredientId;
      var row = el('div', { class: 'arcp-ar__row' + (matched ? '' : ' is-new') });
      var tap = el('button', { class: 'arcp-ar__tap', type: 'button',
        'aria-label': 'Edit ' + (ing.item || 'this ingredient') }, [
        el('span', { class: 'arcp-ar__qty', text: qtyLabel(ing) }),
        el('span', { class: 'arcp-ar__item' + (ing.item ? '' : ' is-ph'), text: ing.item || 'Tap to fill in' })
      ]);
      tap.addEventListener('click', function () { drawIngs(i); });
      row.appendChild(tap);
      if (matched) {
        row.appendChild(el('span', { class: 'arcp-ar__ok', title: 'Matched to the shared ingredient list', text: '✓' }));
      } else if (ing.item) {
        var nb = el('button', { class: 'arcp-ar__new', type: 'button', text: 'NEW',
          title: 'Not in the shared ingredient list. Tap for the closest matches' });
        nb.addEventListener('click', function (ev) { ev.stopPropagation(); offerMatches(ing, i); });
        row.appendChild(nb);
      }
      bindSwipeDelete(row, i);
      return row;
    }
    function qtyLabel(ing) {
      if (ing.qty == null) return ing.unit ? ing.unit : '—';
      return fmtNum(ing.qty) + (ing.unit ? ' ' + ing.unit : '');
    }
    /* expanded: the four fields the old grid had, minus the permanent
       note column - the note lives here, on the row that needs it */
    function ingEditor(ing, i) {
      var qty = el('input', { class: 'arcp-fld arcp-fld--qty', type: 'text', inputmode: 'decimal',
        placeholder: 'Qty', 'aria-label': 'Quantity' });
      var unit = el('input', { class: 'arcp-fld arcp-fld--unit', type: 'text', placeholder: 'Unit',
        'aria-label': 'Unit' });
      var item = el('input', { class: 'arcp-fld arcp-fld--item', type: 'text', placeholder: 'Ingredient',
        'aria-label': 'Ingredient' });
      if (VOCAB.length) item.setAttribute('list', VOCAB_LIST_ID);
      var note = el('input', { class: 'arcp-fld arcp-fld--note', type: 'text',
        placeholder: 'Note · softened, room temperature…', 'aria-label': 'Note' });
      if (ing.qty != null) qty.value = fmtNum(ing.qty);
      unit.value = ing.unit || '';
      item.value = ing.item || '';
      note.value = ing.note || '';
      function pull() {
        var q = qty.value.trim().replace(',', '.');
        var qn = q === '' ? null : parseFloat(q);
        if (qn != null && isFinite(qn)) ing.qty = qn; else delete ing.qty;
        if (unit.value.trim()) ing.unit = unit.value.trim().toLowerCase(); else delete ing.unit;
        ing.item = item.value.trim();
        if (note.value.trim()) ing.note = note.value.trim(); else delete ing.note;
        matchIngredient(ing);
        dirty = true;
        syncSave();
      }
      [qty, unit, item, note].forEach(function (f) { f.addEventListener('input', pull); });
      /* picking a vocabulary name fills its canonical unit - one less
         thing to type, and the line then qualifies for the ingredientId */
      item.addEventListener('change', function () {
        var v = vocabByNorm[normName(item.value)];
        /* only when BOTH boxes are empty - see matchIngredient: filling a
           canonical unit onto a bare count is how yolks become grams */
        if (v && !unit.value.trim() && !qty.value.trim() && v.unit !== 'count') unit.value = v.unit;
        pull();
      });
      /* the native datalist arrow is nearly untappable on a phone
         (Mariya, 2026-07-10) - a real button opens a tap-to-fill list */
      var pickBtn = null;
      if (VOCAB.length) {
        pickBtn = el('button', { class: 'arcp-fld__pick', type: 'button', text: '▾',
          'aria-label': 'Choose from the ingredient list' });
        pickBtn.addEventListener('click', function () {
          var sh2 = makeSheet('bottom');
          sh2.head.appendChild(el('span', { class: 'arcp-sheet__h2', text: 'Ingredient list' }));
          var d2 = el('button', { class: 'arcp-sheet__done', type: 'button', text: 'Done' });
          d2.addEventListener('click', function () { sh2.close(); });
          sh2.head.appendChild(d2);
          VOCAB.forEach(function (v) {
            var b = el('button', { class: 'arcp-menuitem', type: 'button',
              text: v.name + (v.unit && v.unit !== 'count' ? ' · ' + v.unit : '') });
            b.addEventListener('click', function () {
              item.value = v.name;
              item.dispatchEvent(new Event('change'));
              sh2.close();
            });
            sh2.body.appendChild(b);
          });
          sh2.open();
        });
      }
      var rm = el('button', { class: 'arcp-ar__rm', type: 'button', text: 'Remove' });
      rm.addEventListener('click', function () {
        draft.ingredients.splice(i, 1); dirty = true; drawIngs();
      });
      var doneB = el('button', { class: 'arcp-ar__done', type: 'button', text: 'Done' });
      doneB.addEventListener('click', function () { pull(); drawIngs(); });
      /* the NAME gets the full width and the numbers share the line
         below it. Four fields abreast left 113px for the ingredient at
         375px - and the name is the field the vocabulary match, and so
         the whole shopping list, depends on. */
      var nameRow = [item];
      if (pickBtn) nameRow.push(pickBtn);
      return el('div', { class: 'arcp-ar__edit' }, [
        el('div', { class: 'arcp-ar__editrow' }, nameRow),
        el('div', { class: 'arcp-ar__editrow' }, [qty, unit]),
        note,
        el('div', { class: 'arcp-ar__editact' }, [rm, mode === 'manual' ? null : doneB])
      ]);
    }
    /* the NEW state is an offer, not a scolding: the closest vocabulary
       names, or keep her own wording (which is fine - that line simply
       groups under "Everything else" in the shopping list) */
    function offerMatches(ing, i) {
      var sh2 = makeSheet('bottom');
      sh2.panel.classList.add('arcp-sheet__panel--menu');
      sh2.head.appendChild(el('span', { class: 'arcp-sheet__h2', text: ing.item }));
      var d2 = el('button', { class: 'arcp-sheet__done', type: 'button', text: 'Done' });
      d2.addEventListener('click', function () { sh2.close(); });
      sh2.head.appendChild(d2);
      sh2.head.appendChild(el('span', { class: 'arcp-sheet__sub',
        text: 'Matching the shared list is what makes this line add up with your other cakes in the Planner’s shopping list.' }));
      var near = nearVocab(ing.item);
      near.forEach(function (v) {
        var b = el('button', { class: 'arcp-menuitem', type: 'button',
          text: v.name + (v.unit && v.unit !== 'count' ? ' · ' + v.unit : '') });
        b.addEventListener('click', function () {
          ing.item = v.name;
          if (!ing.unit && ing.qty == null && v.unit !== 'count') ing.unit = v.unit;
          matchIngredient(ing);
          dirty = true;
          sh2.close();
          drawIngs();
        });
        sh2.body.appendChild(b);
      });
      if (!near.length) {
        sh2.body.appendChild(el('p', { class: 'arcp-tsheet__none',
          text: 'Nothing close in the shared list. Your own wording is the right answer here.' }));
      }
      var keep = el('button', { class: 'arcp-menuitem', type: 'button', text: 'Keep as my own wording' });
      keep.addEventListener('click', function () { sh2.close(); });
      sh2.body.appendChild(keep);
      sh2.open();
    }
    /* swipe-left reveals Delete rather than deleting on the gesture -
       an unrecoverable delete from a stray sideways scroll is not a
       trade this page makes anywhere else */
    function bindSwipeDelete(row, i) {
      var x0 = 0, y0 = 0, live = false, open = false;
      row.addEventListener('pointerdown', function (ev) {
        if (ev.pointerType === 'mouse' && ev.button !== 0) return;
        x0 = ev.clientX; y0 = ev.clientY; live = true;
      });
      row.addEventListener('pointermove', function (ev) {
        if (!live) return;
        var dx = ev.clientX - x0, dy = ev.clientY - y0;
        if (Math.abs(dy) > Math.abs(dx)) { live = false; return; }   /* that was a scroll */
        if (dx < -12 && !open) {
          open = true; live = false;
          row.classList.add('is-swiped');
          var del = el('button', { class: 'arcp-ar__swdel', type: 'button', text: 'Delete' });
          del.addEventListener('click', function (e2) {
            e2.stopPropagation();
            draft.ingredients.splice(i, 1); dirty = true; drawIngs();
          });
          row.appendChild(del);
        } else if (dx > 12 && open) {
          open = false; live = false;
          row.classList.remove('is-swiped');
          var d = row.querySelector('.arcp-ar__swdel');
          if (d) d.remove();
        }
      });
      row.addEventListener('pointerup', function () { live = false; });
      row.addEventListener('pointercancel', function () { live = false; });
    }

    /* -- method -- */
    var methodHead = el('button', { class: 'arcp-beyebrow arcp-beyebrow--btn', type: 'button' });
    var methodBox = el('div', { class: 'arcp-arsteps' });
    var allSteps = mode === 'manual';
    methodHead.addEventListener('click', function () { allSteps = !allSteps; drawMethod(); });
    var addStep = el('button', { class: 'arcp-blink', type: 'button', text: '+ Add a step' });
    addStep.addEventListener('click', function () {
      draft.method.push(''); dirty = true; allSteps = true; drawMethod(draft.method.length - 1);
    });
    function drawMethod(openIdx) {
      clearNode(methodBox);
      methodHead.textContent = 'METHOD · ' + draft.method.length +
        (draft.method.length === 1 ? ' STEP' : ' STEPS');
      draft.method.forEach(function (s, i) {
        if (allSteps || openIdx === i) {
          var ta = el('textarea', { class: 'arcp-fld arcp-fld--step', rows: '2',
            'aria-label': 'Step ' + (i + 1) });
          ta.value = s;
          ta.addEventListener('input', function () { draft.method[i] = ta.value; dirty = true; });
          var rm = el('button', { class: 'arcp-ar__rm', type: 'button', text: 'Remove' });
          rm.addEventListener('click', function () { draft.method.splice(i, 1); dirty = true; drawMethod(); });
          methodBox.appendChild(el('div', { class: 'arcp-arstep arcp-arstep--edit' }, [
            el('span', { class: 'arcp-arstep__n', text: String(i + 1) }),
            el('div', { class: 'arcp-arstep__b' }, [ta, rm])
          ]));
          return;
        }
        var b = el('button', { class: 'arcp-arstep', type: 'button' }, [
          el('span', { class: 'arcp-arstep__n', text: String(i + 1) }),
          el('span', { class: 'arcp-arstep__t', text: s || 'Tap to write this step' })
        ]);
        b.addEventListener('click', function () { drawMethod(i); });
        methodBox.appendChild(b);
      });
      if (!draft.method.length) {
        methodBox.appendChild(el('p', { class: 'arcp-arempty', text: 'No method yet. Optional, but it is what the Planner prints on the day.' }));
      }
    }

    /* -- footer -- */
    var err = el('p', { class: 'arcp-berr', role: 'alert' });
    var saveB = el('button', { class: 'arcp-bsave', type: 'button', text: 'SAVE RECIPE' });
    saveB.addEventListener('click', function () { commit(); });
    var foot = el('div', { class: 'arcp-arfoot' }, [err, saveB]);

    function valid() {
      return !!(draft.title || '').trim() && !!draft.category &&
        draft.ingredients.some(function (x) { return (x.item || '').trim(); });
    }
    function syncSave() {
      var ok = valid();
      saveTop.classList.toggle('is-on', ok);
      saveB.classList.toggle('is-on', ok);
    }
    function commit() {
      err.textContent = '';
      var title = (draft.title || '').trim();
      if (!title) {
        nameI.classList.add('is-bad');
        err.textContent = 'Give the recipe a name.';
        try { nameI.focus({ preventScroll: true }); } catch (e) { }
        return;
      }
      if (!draft.category) {
        catBtn.classList.add('is-bad');
        err.textContent = 'Pick a component. It decides where this recipe files and how the Planner treats it.';
        return;
      }
      var ings = draft.ingredients.filter(function (x) { return (x.item || '').trim(); })
        .map(function (x) {
          var o = { item: x.item.trim() };
          if (x.qty != null) o.qty = x.qty;
          if (x.unit) o.unit = x.unit;
          if (x.note) o.note = x.note;
          if (x.ingredientId) o.ingredientId = x.ingredientId;
          return o;
        });
      if (!ings.length) {
        err.textContent = 'Add at least one ingredient (a name on its own is enough).';
        return;
      }
      /* r205 (Mariya: "let's make the saved yield mandatory"). A recipe
         with no yield cannot be sized to a cake, so every tool downstream
         guessed. The ingredient weights give an honest prefill; she
         confirms or corrects it, and the save waits until she has. */
      if (!(draft.yieldG > 0)) {
        var estG = 0;
        ings.forEach(function (i) {
          var u = ((i.unit || '') + '').trim().toLowerCase();
          if (+i.qty > 0 && (u === 'g' || u === 'ml')) estG += +i.qty;
          else if (+i.qty > 0 && u === 'kg') estG += +i.qty * 1000;
        });
        estG = Math.round(estG / 10) * 10;
        /* r205b (Mariya: "can't the recipe automatically calculate the
           yield?"). It can, and it does: the ingredient weights ARE what
           one batch makes, so the yield fills itself in, marked as
           calculated. Only a recipe with nothing in grams still asks. */
        if (estG > 0) {
          draft.yieldG = estG; draft.yieldEst = true;
        } else {
          err.textContent = '';
          err.appendChild(el('span', { text: 'How much does one batch make in grams? Nothing here is weighed, so it cannot be worked out. ' }));
          var setIt = el('button', { class: 'arcp-linkbtn', type: 'button', text: 'Enter the grams' });
          setIt.addEventListener('click', function () { editYield(draft, function () { dirty = true; drawHead(); }); });
          err.appendChild(setIt);
          return;
        }
      }
      if (!draft.id && mine.items.length >= MINE_MAX) {
        /* r53: at the cap, the free tier hears the pitch - this is the ONE
           place it appears. Editing an existing recipe is never blocked. */
        if (!MINE_PRO) {
          err.innerHTML = 'Your three free slots are full. <a href="/products/learn-hub-pro">LAYER’D Toolkit Pro</a> saves 100 recipes, synced to your account.';
        } else {
          err.textContent = 'You have reached the ' + MINE_MAX + '-recipe limit. Delete one to add another.';
        }
        return;
      }
      var rec = {
        id: draft.id || mineId(),
        title: title,
        category: draft.category,
        ingredients: ings,
        method: draft.method.map(function (s) { return String(s).trim(); }).filter(Boolean)
      };
      if (draft.yieldNote) rec.yieldNote = draft.yieldNote;
      /* yieldG is the build's spelling of the master's yieldGrams, and it
         is what Batch Math turns into batch counts - never drop it */
      if (draft.yieldG > 0) rec.yieldG = draft.yieldG;
      if (draft.yieldG > 0 && draft.yieldEst) rec.yieldEst = true;   /* calculated, not weighed */
      /* r212: a base copied from a studio recipe arrives with the pan its
         batch fills. The editor has no control for it, so it rides along
         untouched rather than being lost on the first save. */
      if (draft.panBasis && +draft.panBasis.d > 0 && +draft.panBasis.layers > 0) rec.panBasis = draft.panBasis;
      if (draft.id) {
        for (var j = 0; j < mine.items.length; j++) {
          if (mine.items[j].id === draft.id) { mine.items[j] = rec; break; }
        }
      } else {
        mine.items.push(rec);
      }
      if (!writeMine()) { err.textContent = 'Could not save in this browser (private mode?).'; return; }
      trackUsed();
      editingId = null;
      dirty = false;
      sh.close();
      renderLibrary();
    }

    sh.body.appendChild(el('div', { class: 'arcp-bfield' }, [
      el('span', { class: 'arcp-beyebrow', text: 'NAME' }), nameI
    ]));
    sh.body.appendChild(el('div', { class: 'arcp-ar__meta' }, [
      el('div', { class: 'arcp-ar__metarow' }, [
        el('div', { class: 'arcp-ar__metab' }, [
          el('span', { class: 'arcp-beyebrow', text: 'COMPONENT' }), catVal
        ]), catBtn
      ]),
      el('div', { class: 'arcp-ar__metarow' }, [
        el('div', { class: 'arcp-ar__metab' }, [
          el('span', { class: 'arcp-beyebrow', text: 'MAKES' }), yieldVal
        ]), yieldBtn
      ])
    ]));
    sh.body.appendChild(el('div', { class: 'arcp-arsec' }, [
      el('div', { class: 'arcp-arsec__h' }, [ingHead, el('span', { class: 'arcp-arsec__rule' })]),
      ingBox, addIng
    ]));
    sh.body.appendChild(el('div', { class: 'arcp-arsec' }, [
      el('div', { class: 'arcp-arsec__h' }, [methodHead, el('span', { class: 'arcp-arsec__rule' })]),
      methodBox, addStep
    ]));
    sh.panel.appendChild(foot);

    if (!draft.ingredients.length) draft.ingredients.push({ item: '' });
    drawHead();
    drawIngs();
    drawMethod();
    syncSave();
    sh.open();
    if (mode === 'manual' && !draft.title) { try { nameI.focus({ preventScroll: true }); } catch (e) { } }
    return sh;
  }

  /* ---------- Screen 1: the front door ---------- */
  function openAddEntry(prefillTitle) {
    /* a name typed into the picker's "add it as a new recipe" is already
       an answer to "where is this recipe" - go straight to the editor */
    if (prefillTitle) {
      openRecipeEditor({ title: prefillTitle, category: '',
        ingredients: [], method: [] }, { mode: 'manual', title: 'NEW RECIPE', dirty: true });
      trackEntry('manual');
      return;
    }
    var sh = makeSheet('full');
    sh.panel.classList.add('arcp-sheet__panel--entry');
    var cancel = el('button', { class: 'arcp-sheet__cancel', type: 'button', text: 'Cancel' });
    cancel.addEventListener('click', function () { sh.close(); });
    sh.head.appendChild(cancel);
    sh.head.appendChild(el('span', { class: 'arcp-sheet__title', text: 'NEW RECIPE' }));
    /* Save stays disabled here on purpose: there is no recipe yet */
    sh.head.appendChild(el('span', { class: 'arcp-sheet__act', 'aria-hidden': 'true', text: 'Save' }));

    function goEditor(draft, entry) {
      trackEntry(entry);
      sh.close();
      openRecipeEditor(draft, { dirty: true, backTo: function () { openAddEntry(); } });
    }
    /* the handoff's rule zero: under two ingredient lines is a failed
       parse, and a failed parse must never eat the paste - the manual
       editor opens with the raw text kept as rows */
    function handleText(text, entry) {
      text = maybeDecode(text);
      var draft = parseRecipe(text);
      if (draft.ingredients.length < 2) {
        var rows = String(text || '').split(/\r?\n/)
          .map(function (l) { return l.trim(); }).filter(Boolean)
          .map(function (l) { return parseIngredientLine(l) || { item: l }; });
        trackEntry(entry);
        sh.close();
        openRecipeEditor({
          title: draft.title || '', category: draft.category,
          ingredients: rows.length ? rows.map(matchIngredient) : [{ item: '' }],
          method: [], yieldNote: draft.yieldNote, yieldG: draft.yieldG
        }, { mode: 'manual', title: 'NEW RECIPE', dirty: true,
          backTo: function () { openAddEntry(); } });
        return;
      }
      goEditor(draft, entry);
    }

    /* -- the paste panel -- */
    var panel = el('div', { class: 'arcp-paste2' });
    var ta = null;
    var pasteBtn = el('button', { class: 'arcp-paste2__go', type: 'button', text: 'Paste from clipboard' });
    function becomeTextarea(msg) {
      if (ta) { parse(); return; }
      ta = el('textarea', { class: 'arcp-paste2__ta', rows: '6',
        placeholder: 'Paste your recipe here. Name, ingredients one per line, then the method.',
        'aria-label': 'Paste your recipe' });
      panel.insertBefore(ta, pasteBtn);
      /* r187: pasting into the box IS the intent - parse the moment the
         paste lands (the tick lets the value commit first) instead of
         demanding a second tap on PARSE. Typed/edited text still uses
         the button. */
      ta.addEventListener('paste', function () { setTimeout(parse, 60); });
      if (msg) panel.insertBefore(el('p', { class: 'arcp-paste2__note', role: 'status', text: msg }), ta);
      pasteBtn.textContent = 'PARSE';
      try { ta.focus({ preventScroll: true }); } catch (e) { }
    }
    function parse() {
      var text = ta ? ta.value : '';
      if (!String(text).trim()) {
        if (!panel.querySelector('.arcp-paste2__note')) {
          panel.insertBefore(el('p', { class: 'arcp-paste2__note', role: 'status',
            text: 'Nothing to read yet. Paste the recipe in above.' }), ta);
        }
        return;
      }
      handleText(text, 'paste');
    }
    pasteBtn.addEventListener('click', function () {
      if (ta) { parse(); return; }
      var read = null;
      try {
        if (navigator.clipboard && navigator.clipboard.readText) read = navigator.clipboard.readText();
      } catch (e) { read = null; }
      if (!read) {
        becomeTextarea('This browser keeps its clipboard private. Tap the box, hold, and Paste. It reads itself the moment it lands.');
        return;
      }
      read.then(function (text) {
        if (!String(text || '').trim()) {
          becomeTextarea('Your clipboard looks empty. Tap the box, hold, and Paste. It reads itself the moment it lands.');
          return;
        }
        handleText(text, 'paste');
      }, function () {
        becomeTextarea('This browser keeps its clipboard private. Tap the box, hold, and Paste. It reads itself the moment it lands.');
      });
    });
    panel.appendChild(el('span', { class: 'arcp-paste2__t', text: 'Paste your recipe' }));
    panel.appendChild(pasteBtn);
    /* dropping a .txt / .md on the panel parses it the same way */
    panel.addEventListener('dragover', function (ev) { ev.preventDefault(); panel.classList.add('is-drop'); });
    panel.addEventListener('dragleave', function () { panel.classList.remove('is-drop'); });
    panel.addEventListener('drop', function (ev) {
      ev.preventDefault();
      panel.classList.remove('is-drop');
      var f = ev.dataTransfer && ev.dataTransfer.files && ev.dataTransfer.files[0];
      if (!f) return;
      var fr = new FileReader();
      fr.onload = function () { handleText(String(fr.result || ''), 'paste'); };
      fr.readAsText(f);
    });
    sh.body.appendChild(panel);

    /* r185 built this sheet as the camera door itself; r186 (Mariya,
       2026-08-31, after testing: "I see this iphone method causing people
       to message me for instructions") demotes it to the FALLBACK. The
       primary path is now one-tap: photo -> the Worker's /ocr route ->
       the same paste pipeline. This sheet appears when that path cannot
       (logged out, offline, worker unconfigured, rate-limited, or the
       photo had no recipe in it) - so the feature degrades to the
       zero-maintenance version instead of to an error.
       Decision record: docs/camera-scan-runbook.md */
    function openScanSheet(note) {
      var ua = navigator.userAgent || '';
      var isIOS = /iPhone|iPad|iPod/.test(ua);
      var isAndroid = /Android/.test(ua);
      var steps = isIOS ? [
        'Open the Camera app and point it at the recipe.',
        'Tap the Live Text button in the corner of the frame (it looks like three lines in a box).',
        'Touch and hold the recipe text, drag to select all of it, then tap Copy.',
        'Come back here and tap the button below.'
      ] : isAndroid ? [
        'Open the camera or Google Lens and point it at the recipe.',
        'Tap Text, then Select all, then Copy.',
        'Come back here and tap the button below.'
      ] : [
        'On your phone, point the camera at the recipe and use Live Text (iPhone) or Lens (Android) to copy the text.',
        'On this computer, use the paste box instead, or drop a .txt file straight onto it.'
      ];
      var sh2 = makeSheet('bottom');
      sh2.panel.classList.add('arcp-sheet__panel--menu');
      sh2.head.appendChild(el('span', { class: 'arcp-sheet__h2', text: 'Snap a page' }));
      var d2 = el('button', { class: 'arcp-sheet__done', type: 'button', text: 'Done' });
      d2.addEventListener('click', function () { sh2.close(); });
      sh2.head.appendChild(d2);
      /* r190 (Mariya): no default sub-note - "I dislike unnecessary
         jargon." The numbered steps say everything. A note still renders
         when the sheet opens as a FALLBACK, because those lines carry the
         reason (logged out / daily cap / no recipe found), not filler. */
      if (note) sh2.head.appendChild(el('span', { class: 'arcp-sheet__sub', text: note }));
      var list = el('ol', { class: 'arcp-scan__steps' });
      steps.forEach(function (s) { list.appendChild(el('li', { text: s })); });
      sh2.body.appendChild(list);
      if (isIOS || isAndroid) {
        var go = el('button', { class: 'arcp-paste2__go arcp-scan__go', type: 'button',
          text: 'I copied it. Paste' });
        go.addEventListener('click', function () {
          /* close the how-to, then fire the entry screen's own paste
             button — same clipboard logic, same fallback, verbatim */
          sh2.close();
          pasteBtn.click();
        });
        sh2.body.appendChild(go);
      }
      sh2.open();
    }

    /* ---- r186: the one-tap camera door ----
       Photo (or a screenshot from the library - accept without capture
       so iOS offers both) -> downscaled JPEG on a canvas -> POST to the
       Worker's /ocr route behind the same app-proxy door as cloud sync
       -> the returned text goes through handleText() exactly like a
       paste. EVERY failure lands on openScanSheet() with an honest
       one-line reason, so the tile never dead-ends. */
    /* r188 (Mariya): the one-tap OCR is ON THE FUTURE LIST, not live —
       so the tile must not fish for a photo it cannot read. false = the
       CAMERA tile opens the guided Live-Text sheet directly (the r185
       behaviour, zero moving parts). FLIP TO true ONLY as part of the
       camera runbook's deploy steps, after the Worker carries the
       ANTHROPIC_API_KEY secret — the one-tap code below is finished,
       verified and waiting behind this one word. */
    var OCR_ENABLED = false;
    var OCR_URL = '/apps/toolkit/ocr';
    var scanBusy = false;
    function setScanStatus(msg) {
      if (!scanStatusEl) return;
      scanStatusEl.textContent = msg || '';
      scanStatusEl.hidden = !msg;
    }
    function snapPhoto() {
      if (scanBusy) return;
      var input = el('input', { type: 'file', accept: 'image/*' });
      input.addEventListener('change', function () {
        var f = input.files && input.files[0];
        if (!f) return;
        trackEntry('photo');
        scanBusy = true;
        setScanStatus('Reading your photo… the picture is sent securely to read the text, then discarded.');
        shrinkImage(f, function (b64) {
          if (!b64) {
            scanBusy = false; setScanStatus('');
            openScanSheet('That photo could not be read here. The hands-on way always works:');
            return;
          }
          sendScan(b64);
        });
      });
      input.click();
    }
    function shrinkImage(file, done) {
      var img = new Image();
      var url = URL.createObjectURL(file);
      img.onload = function () {
        try {
          var MAXD = 1568;
          var scale = Math.min(1, MAXD / Math.max(img.naturalWidth, img.naturalHeight));
          var c = document.createElement('canvas');
          c.width = Math.max(1, Math.round(img.naturalWidth * scale));
          c.height = Math.max(1, Math.round(img.naturalHeight * scale));
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          var data = c.toDataURL('image/jpeg', 0.82);
          /* base64 must stay well under the Worker's 2 MB body cap */
          if (data.length > 1400000) data = c.toDataURL('image/jpeg', 0.6);
          URL.revokeObjectURL(url);
          done(data.split(',')[1] || null);
        } catch (e) { URL.revokeObjectURL(url); done(null); }
      };
      img.onerror = function () { URL.revokeObjectURL(url); done(null); };
      img.src = url;
    }
    function sendScan(b64) {
      var ac = ('AbortController' in window) ? new AbortController() : null;
      var timer = ac ? setTimeout(function () { ac.abort(); }, 60000) : null;
      fetch(OCR_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        signal: ac ? ac.signal : undefined,
        body: JSON.stringify({ image: b64, media: 'image/jpeg' })
      }).then(function (res) {
        if (timer) clearTimeout(timer);
        return res.json().catch(function () { return {}; }).then(function (data) {
          scanBusy = false; setScanStatus('');
          if (res.status === 401) {
            openScanSheet('One-tap reading needs you to be logged in. The hands-on way works for everyone:');
            return;
          }
          if (res.status === 429) {
            openScanSheet('That is a lot of scans for one day. The hands-on way still works:');
            return;
          }
          if (res.ok && data && data.ok && data.text) {
            handleText(data.text, 'photo');
            return;
          }
          if (data && data.error === 'no-recipe') {
            openScanSheet('I could not find a recipe in that photo. Try a closer shot, or the hands-on way:');
            return;
          }
          openScanSheet('The photo reader is not answering right now. The hands-on way always works:');
        });
      }).catch(function () {
        if (timer) clearTimeout(timer);
        scanBusy = false; setScanStatus('');
        openScanSheet('The photo reader is not answering right now. The hands-on way always works:');
      });
    }

    /* -- the two tiles -- */
    function tile(eyebrow, title, fn) {
      var b = el('button', { class: 'arcp-tile', type: 'button' }, [
        el('span', { class: 'arcp-tile__e', text: eyebrow }),
        el('span', { class: 'arcp-tile__t', text: title })
      ]);
      if (fn) b.addEventListener('click', fn);
      else { b.disabled = true; b.classList.add('is-off'); }
      return b;
    }
    /* CAMERA ships disabled, not omitted and never as a dead tap: there
       is no OCR in this bundle, and a tile that silently does nothing is
       the one thing the handoff rules out. The eyebrow says why. */
    var scanStatusEl = el('p', { class: 'arcp-scanstatus', role: 'status', hidden: 'hidden' });
    sh.body.appendChild(el('div', { class: 'arcp-tiles' }, [
      tile('CAMERA', 'Snap a page', function () { if (OCR_ENABLED) snapPhoto(); else openScanSheet(); }),
      tile('MANUAL', 'Type it out', function () {
        goEditorManual();
      })
    ]));
    sh.body.appendChild(scanStatusEl);
    function goEditorManual() {
      trackEntry('manual');
      sh.close();
      openRecipeEditor({ title: '', category: '', ingredients: [], method: [] },
        { mode: 'manual', title: 'NEW RECIPE', backTo: function () { openAddEntry(); } });
    }

    /* -- or start from -- */
    sh.body.appendChild(el('div', { class: 'arcp-orfrom' }, [
      el('span', { class: 'arcp-beyebrow', text: 'OR START FROM' }),
      el('span', { class: 'arcp-arsec__rule' })
    ]));
    function sourceRow(title, tailNode, fn) {
      var b = el('button', { class: 'arcp-srcrow', type: 'button' }, [
        el('span', { class: 'arcp-srcrow__t', text: title }), tailNode
      ]);
      b.addEventListener('click', fn);
      return b;
    }
    sh.body.appendChild(sourceRow('Duplicate a recipe',
      el('span', { class: 'arcp-srcrow__c', 'aria-hidden': 'true', text: '›' }),
      function () { pickSource(readMine().items || [], 'Duplicate a recipe', 'duplicate'); }));
    /* Academy only - for Pro the row is absent, not locked (handoff) */
    if (IS_ACADEMY && DATA && DATA.recipes.length) {
      sh.body.appendChild(sourceRow('A studio recipe',
        el('span', { class: 'arcp-srcrow__a', text: 'Academy' }),
        function () { pickSource(DATA.recipes, 'A studio recipe', 'studio'); }));
    }
    function pickSource(list, title, entry) {
      var pk = makeSheet('bottom');
      pk.head.appendChild(el('span', { class: 'arcp-sheet__h2', text: title }));
      var d = el('button', { class: 'arcp-sheet__done', type: 'button', text: 'Done' });
      d.addEventListener('click', function () { pk.close(); });
      pk.head.appendChild(d);
      if (!list.length) {
        pk.body.appendChild(el('p', { class: 'arcp-tsheet__none', text: 'Nothing to copy yet.' }));
      }
      list.forEach(function (r) {
        var b = el('button', { class: 'arcp-presult', type: 'button' }, [
          el('span', { class: 'arcp-presult__b' }, [
            el('span', { class: 'arcp-presult__t', text: r.title + (r.variation ? ' · ' + r.variation : '') }),
            el('span', { class: 'arcp-presult__s', text: [shortYield(r.yieldNote),
              (r.ingredients || []).length + ' ingredients'].filter(Boolean).join(' · ') })
          ]),
          el('span', { class: 'arcp-tick', 'aria-hidden': 'true' })
        ]);
        b.addEventListener('click', function () {
          var copy = JSON.parse(JSON.stringify(r));
          delete copy.id; delete copy.access; delete copy.pairsWith;
          /* r212: panBasis STAYS. It is what one batch of this recipe
             fills, and the costing door sizes a base against it — dropping
             it made her copy of a studio sponge fall back to the studio
             default and quietly size differently from the original. */
          delete copy.verified; delete copy._verify;
          copy.title = (copy.title || 'Recipe') + ' copy';
          copy.ingredients = (copy.ingredients || []).map(function (x) {
            return matchIngredient(JSON.parse(JSON.stringify(x)));
          });
          copy.method = copy.method || [];
          if (copy.yieldGrams != null && copy.yieldG == null) copy.yieldG = copy.yieldGrams;
          delete copy.yieldGrams;
          pk.close();
          goEditor(copy, entry);
        });
        pk.body.appendChild(b);
      });
      pk.open();
    }
    sh.open();
  }
  /* which door was used - it is the only way to learn whether paste is
     actually winning (handoff, `entryMode`) */
  function trackEntry(mode) {
    try {
      if (typeof window.lhTrack === 'function') {
        window.lhTrack('recipe_entry', { tool: 'recipes', entry_mode: mode, tier: boxTier() });
      }
    } catch (e) { }
  }

  /* the one opener every other surface calls */
  function openAddSheet(prefillTitle) { openAddEntry(prefillTitle); }
  /* Edit lands on the same editor, on a copy, so Cancel really cancels */
  function openForm(r) {
    editingId = r.id;
    var draft = JSON.parse(JSON.stringify(r));
    draft.ingredients = (draft.ingredients || []).map(matchIngredient);
    draft.method = draft.method || [];
    openRecipeEditor(draft, { title: 'EDIT RECIPE' });
  }

  /* ---------- GA4: re-bound to the redesigned recipe-box points ----------
     Fires through the shared learn-hub-analytics helper (window.lhTrack)
     and fails silently when analytics isn't loaded. tool_used counts the
     first genuine interaction (open / add / scale); cta_clicked marks the
     Batch Math + Planner cross-links. */
  var usedFired = false;
  function boxTier() {
    var host = document.querySelector('[data-lh-tier]');
    var t = host && host.getAttribute('data-lh-tier');
    return (t === 'free' || t === 'premium' || t === 'visitor') ? t : 'premium';
  }
  function trackUsed() {
    if (usedFired) return;
    usedFired = true;
    try { if (typeof window.lhTrack === 'function')
      window.lhTrack('learn_hub_tool_used', { tool_name: 'recipe_box', user_tier: boxTier() }); }
    catch (e) { /* analytics never breaks the tool */ }
  }
  function trackCta(ctaType) {
    try { if (typeof window.lhTrack === 'function')
      window.lhTrack('learn_hub_cta_clicked', { tool_name: 'recipe_box', cta_type: ctaType, user_tier: boxTier() }); }
    catch (e) { /* analytics never breaks the tool */ }
  }

  /* ---------- clipboard (shared by the open-recipe Copy link) ---------- */
  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text; ta.setAttribute('readonly', '');
    ta.style.position = 'absolute'; ta.style.left = '-9999px';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch (e) { /* nothing more we can do */ }
    document.body.removeChild(ta);
  }
  function doCopy(text, btn, doneLabel, resetLabel) {
    function done() {
      btn.textContent = doneLabel;
      setTimeout(function () { btn.textContent = resetLabel; }, 1600);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, function () { legacyCopy(text); done(); });
    } else { legacyCopy(text); done(); }
  }

  function catLabel(id) {
    var c = catById[id];
    return c ? c.label.split(' · ')[0] : 'Other';
  }

  /* ---------- one library row (r182 "Combos on top") ----------
     The 2-up gallery of tinted plates is gone: the category name lives
     ONCE on the accordion header, so a row carries only what is different
     about the recipe — its name, never truncated, and a nowrap meta of
     "{yield} · {ingredientCount}". Density goes from ~4 recipes a screen
     to ~12, which is the whole point of the redesign. ---------- */
  /* the row meta is deliberately terser than the open recipe's: the yield
     note gets shortened to its first clause and the ingredient count is a
     bare number, so the pair always fits on one nowrap line beside a
     two-line recipe name. */
  function shortYield(y) {
    var s = (y || '').trim();
    if (!s) return '';
    /* one clause only, and no hedging word in front of it - "About two
       6-inch layers (or one 8-inch)" has to become "Two 6-inch layers"
       to sit on one nowrap line beside a two-line recipe name */
    s = s.split(/[;(]|\s+—\s+|\s+-\s+/)[0].trim().replace(/[.,]$/, '');
    s = s.replace(/^(?:about|approx\.?|approximately|roughly|makes|yields|around)\s+/i, '');
    if (s.length > 22) s = s.slice(0, 21).replace(/\s+\S*$/, '') + '…';
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : '';
  }
  /* r205d (Mariya: "if it says 250 g it should convert to makes: 1 cup").
     A Makes note derived from the grams, at DISPLAY time - never written
     onto the recipe, so a note she types always wins. 240 g to the cup,
     to the nearest quarter; batter says so, because a cup of batter is
     not a serving of anything. */
  var G_PER_CUP = 240;
  function cupsNote(r) {
    var g = +(r && (r.yieldG != null ? r.yieldG : r.yieldGrams));
    if (!(g > 0)) return '';
    var q = Math.max(1, Math.round((g / G_PER_CUP) * 4));   /* quarter cups */
    var whole = Math.floor(q / 4), frac = q % 4;
    var fr = ['', '¼', '½', '¾'][frac];
    var n = (whole ? String(whole) : '') + fr;
    var unit = (whole === 1 && !frac) || (!whole) ? ' cup' : ' cups';
    return '≈ ' + n + unit + (r.category === 'bases' ? ' of batter' : '');
  }
  /* r-2026-09-17 (Mariya: scaling "1/4 sheet" ×2 read "× 2 of 1/4 sheet", not
     "½ sheet"). A sheet-pan yield IS a pan count, so it scales cleanly - parse
     the count in front of "sheet" (words / ascii / unicode fractions), multiply
     by the factor, and re-express in nice quarter-sheet steps. Returns null for
     anything that isn't a plain sheet count, so every other written yield keeps
     the honest "× N of ..." fallback. */
  function scaleSheetYield(note, factor) {
    var s = String(note || '').trim();
    if (!/sheets?\b/i.test(s)) return null;
    var before = s.split(/sheets?\b/i)[0]
      .replace(/\bpans?\b/gi, ' ')
      .replace(/\bof\b/gi, ' ')
      .replace(/\b(?:about|approx\.?|approximately|roughly|makes|yields?|around)\b/gi, ' ')
      .trim();
    var base;
    if (/three[\s-]*quarter/i.test(before)) base = 0.75;
    else if (/quarter/i.test(before)) base = 0.25;
    else if (/half/i.test(before)) base = 0.5;
    else if (before === '' || (/\b(?:one|full|whole)\b/i.test(before) && !/[\d\/]/.test(before))) base = 1;
    else base = fracToNumber(before);
    if (base == null || !isFinite(base) || base <= 0) return null;
    var q = Math.round(base * factor * 4);           /* quarter-sheet steps */
    if (q <= 0) return null;
    var whole = Math.floor(q / 4), frac = q % 4;
    var fr = ['', '¼', '½', '¾'][frac];
    var num = (whole ? String(whole) : '') + fr;
    return num + ' sheet' + (q > 4 ? 's' : '');
  }
  function makesOf(r) { return (r && r.yieldNote) ? r.yieldNote : cupsNote(r); }
  function rowMeta(r) {
    var meta = [];
    if (r.placeholder) meta.push('coming soon');
    var mk = makesOf(r);
    if (mk) meta.push(mk);
    if (!r.placeholder) meta.push(r.ingredients.length + ' ingredient' + (r.ingredients.length === 1 ? '' : 's'));
    return meta;
  }
  function rowMetaShort(r) {
    if (r.placeholder) return 'coming soon';
    var bits = [];
    var y = r.yieldNote ? shortYield(r.yieldNote) : cupsNote(r);
    if (y) bits.push(y);
    /* r205c (Mariya: "is that number of ingredients?") - a bare "7" read
       as nothing to the owner, so it says what it counts */
    var n = (r.ingredients || []).length;
    bits.push(n + (n === 1 ? ' ingredient' : ' ingredients'));
    return bits.join(' · ');
  }
  function libRow(r, isMine, isSample) {
    var nameEl = el('span', { class: 'arcp-row__name', text: r.title + (r.variation ? ' · ' + r.variation : '') });
    /* 2026-09-14: the free sample now shows as the FIRST row in Your recipes
       with a small "sample" tag beside the name, instead of under a ✦ gold
       divider + card at the foot. */
    var top = isSample
      ? el('span', { class: 'arcp-row__nameline' }, [nameEl, el('span', { class: 'arcp-row__tag', text: 'sample' })])
      : nameEl;
    var row = el('button', {
      class: 'arcp-row' + (r.placeholder ? ' arcp-row--soon' : '') + (isMine ? '' : ' arcp-row--studio') + (isSample ? ' arcp-row--sample' : ''),
      type: 'button'
    }, [
      top,
      el('span', { class: 'arcp-row__meta', text: rowMetaShort(r) })
    ]);
    row.addEventListener('click', function () { openRecipe(r, isMine); });
    /* the design asks for swipe-left (or long-press) -> Edit / Delete on a
       row. Long-press is the one it offers as the fallback and the one
       that cannot be triggered by a scroll that drifts sideways, so a
       flick down the library never opens a delete. Own recipes only. */
    if (isMine) bindLongPress(row, function () { openRowMenu(r); });
    return row;
  }
  /* 500ms, cancelled by any movement over 10px or by the tap ending */
  function bindLongPress(node, fn) {
    var timer = null, x0 = 0, y0 = 0, fired = false;
    function cancel() { if (timer) { clearTimeout(timer); timer = null; } }
    node.addEventListener('pointerdown', function (ev) {
      if (ev.pointerType === 'mouse' && ev.button !== 0) return;
      fired = false; x0 = ev.clientX; y0 = ev.clientY;
      timer = setTimeout(function () { fired = true; timer = null; fn(); }, 500);
    });
    node.addEventListener('pointermove', function (ev) {
      if (timer && (Math.abs(ev.clientX - x0) > 10 || Math.abs(ev.clientY - y0) > 10)) cancel();
    });
    node.addEventListener('pointerup', cancel);
    node.addEventListener('pointercancel', cancel);
    node.addEventListener('contextmenu', function (ev) { if (fired) ev.preventDefault(); });
    /* a long press must not ALSO open the recipe when the finger lifts */
    node.addEventListener('click', function (ev) {
      if (!fired) return;
      fired = false;
      ev.preventDefault(); ev.stopImmediatePropagation();
    }, true);
  }
  function openRowMenu(r, fromOpen, askDelete) {
    var sh = makeSheet('bottom');
    sh.panel.classList.add('arcp-sheet__panel--menu');
    sh.head.appendChild(el('span', { class: 'arcp-sheet__h2', text: r.title }));
    var doneB = el('button', { class: 'arcp-sheet__done', type: 'button', text: 'Done' });
    doneB.addEventListener('click', function () { sh.close(); });
    sh.head.appendChild(doneB);
    var ed = el('button', { class: 'arcp-menuitem', type: 'button', text: 'Edit' });
    ed.addEventListener('click', function () { sh.close(); if (fromOpen) closeRecipe(); openForm(r); });
    var del = el('button', { class: 'arcp-menuitem is-del', type: 'button', text: 'Delete' });
    del.addEventListener('click', function () {
      /* from the open card, the card's own keep / delete bar asks - no
         browser dialog */
      if (askDelete) { sh.close(); askDelete(); return; }
      if (!window.confirm('Delete “' + (r.title || 'this recipe') + '”? This can’t be undone.')) return;
      mine.items = mine.items.filter(function (x) { return x.id !== r.id; });
      writeMine();
      if (editingId === r.id && editorSheet) { editorSheet.close(); editingId = null; }
      sh.close();
      if (currentOpen && currentOpen.r && currentOpen.r.id === r.id) closeRecipe();
      renderLibrary();
    });
    sh.body.appendChild(ed);
    sh.body.appendChild(del);
    sh.open();
  }
  function studioRow(r) { return libRow(r, false); }

  /* ---------- open one recipe (the library hides while this shows) ---------- */
  var currentOpen = null;
  function openRecipe(r, isMine) {
    currentOpen = { r: r, isMine: !!isMine };
    clearNode(mineOpenWrap);
    mineOpenWrap.appendChild(openCard(r, !!isMine));
    mineListWrap.hidden = true;
    mineOpenWrap.hidden = false;
    trackUsed();
    var sec = mineOpenWrap.parentNode;
    if (sec) ldNav(sec);
  }
  function closeRecipe() {
    currentOpen = null;
    mineOpenWrap.hidden = true;
    clearNode(mineOpenWrap);
    mineListWrap.hidden = false;
  }

  /* ---------- the open-recipe view (redesign 15b) ----------
     Back bar \u00b7 eyebrow \u00b7 serif title \u00b7 yield strip (ONE BATCH / TIME /
     SCALE) \u00b7 ingredients as a scannable column \u00b7 method numbered down
     the edge \u00b7 notes + storage in quiet insets \u00b7 quiet action links.
     ONE renderer for studio recipes and yours \u2014 edit/delete only exist
     on yours; pan-rescale only where the recipe carries a pan basis. */
  function openCard(r, isMine) {
    var factor = 1;
    var wrap = el('div', { class: 'arcp-openwrap' });

    var back = el('button', { class: 'arcp-back', type: 'button', text: '\u2039 Recipe library' });
    back.addEventListener('click', closeRecipe);
    wrap.appendChild(el('div', { class: 'arcp-backbar' }, [
      back,
      el('span', { class: 'arcp-backbar__cat', text: catLabel(r.category) })
    ]));

    var card = el('div', { class: 'arcp-open' });

    /* -- header -- */
    /* r205e (Mariya: "I hate the edit and delete buttons for each
       recipe"). Two glyph buttons (a pencil and an x) crowded the title.
       One quiet more-button now, opening the same Edit / Delete sheet the
       row's long-press already has - one menu, two doors. */
    var moreBtn = null;
    if (isMine) {
      moreBtn = el('button', { class: 'arcp-open__more', type: 'button',
        title: 'Edit or delete', 'aria-label': 'Edit or delete this recipe', text: '⋯' });
      moreBtn.addEventListener('click', function () { openRowMenu(r, true, function () { if (confirmBar) confirmBar.hidden = false; }); });
    }
    var head = el('div', { class: 'arcp-open__head' });
    var titleRow = el('div', { class: 'arcp-open__titlerow' }, [
      el('div', { class: 'arcp-open__titles' }, [
        el('div', { class: 'arcp-eyebrow' }, [
          el('span', { class: 'arcp-eyebrow__dash', 'aria-hidden': 'true' }),
          el('span', { class: 'arcp-eyebrow__txt', text: isMine ? 'My recipes' : 'From the LAYER\u2019D studio' })
        ]),
        el('h3', { class: 'arcp-open__title', text: r.title + (r.variation ? ' \u2014 ' + r.variation : '') }),
        r.intro ? el('p', { class: 'arcp-open__lede', text: r.intro }) : null
      ]),
      moreBtn
    ]);
    head.appendChild(titleRow);

    if (r.placeholder) {
      card.appendChild(head);
      card.appendChild(el('p', { class: 'arcp-soon', text:
        'Recipe coming soon \u2014 this component is being finalized for the library.' }));
      wrap.appendChild(card);
      return wrap;
    }

    /* live ingredient render + scaling note */
    var ingList = el('ul', { class: 'arcp-ings' });
    var cautionBox = el('div', {});
    var noteBox = el('div', {});
    function renderNote() {
      clearNode(noteBox);
      if (factor !== 1) {
        noteBox.appendChild(el('p', { class: 'arcp-scalenote', text:
          'Scaled amounts round to the nearest gram \u2014 eggs round to whole eggs, and the scale never rewrites the saved recipe.' }));
      }
    }
    function renderIngs() { fillIngs(r, factor, ingList, cautionBox); renderNote(); updateBatchYield(); }

    /* -- the yield strip: ONE BATCH / TIME / SCALE -- */
    var pb = r.panBasis || null;
    var sel = pb ? { d: pb.d, shape: pb.shape, layers: pb.layers } : null;
    var strip = el('div', { class: 'arcp-strip' });
    var batchTxt = r.yieldNote || (cupsNote(r) ? cupsNote(r) + ' · ' + fmtNum(r.yieldG) + ' g' : '\u2014');
    /* 2026-09-14 (Mariya): the yield figure at the top must follow the scale -
       x2 turns 360 g into 720 g, not stay at one batch. */
    var baseYieldG = +(r.yieldGrams || r.yieldG) || 0;
    var batchLbl = el('span', { class: 'arcp-strip__lbl', text: 'One batch' });
    var batchVal = el('span', { class: 'arcp-strip__val', text: batchTxt });
    function updateBatchYield() {
      if (factor === 1) { batchLbl.textContent = 'One batch'; batchVal.textContent = batchTxt; return; }
      batchLbl.textContent = '× ' + factor + ' batch';
      /* a gram yield scales to a gram total; a sheet-pan yield scales to a bigger
         sheet count ("1/4 sheet" ×2 → "½ sheet"); any other written-only yield
         can't be recomputed, so say plainly it's the written batch scaled rather
         than showing the unscaled note as if it were the new total. */
      var sheetScaled = baseYieldG ? null : scaleSheetYield(batchTxt, factor);
      batchVal.textContent = baseYieldG
        ? '~' + fmtNum(Math.round(baseYieldG * factor)) + ' g'
        : (sheetScaled || ('× ' + factor + ' of ' + batchTxt));
    }
    strip.appendChild(el('div', { class: 'arcp-strip__cell' }, [batchLbl, batchVal]));
    var timeBits = [];
    if (r.activeTime) timeBits.push('Active ' + r.activeTime);
    if (r.setTime) timeBits.push(r.setTime);
    if (timeBits.length) {
      strip.appendChild(el('div', { class: 'arcp-strip__cell' }, [
        el('span', { class: 'arcp-strip__lbl', text: 'Time' }),
        el('span', { class: 'arcp-strip__val', text: timeBits.join(' \u00b7 ') })
      ]));
    }
    var scaleCell = el('div', { class: 'arcp-strip__cell arcp-strip__cell--scale' }, [
      el('span', { class: 'arcp-strip__lbl', text: 'Scale' })
    ]);
    strip.appendChild(scaleCell);

    var rescaleRow = null;
    if (pb) {
      /* pan recipes: the factor reads in the strip; the pan pickers sit
         on their own row right under it (same math as Batch Math) */
      var factorOut = el('span', { class: 'arcp-strip__val arcp-strip__val--factor', text: '\u00d7 1' });
      scaleCell.appendChild(factorOut);
      var sync = function () {
        var f = (panArea(sel) * sel.layers) / (panArea(pb) * pb.layers);
        factor = Math.round(f * 100) / 100;
        factorOut.textContent = '\u00d7 ' + factor;
        trackUsed();
        renderIngs();
      };
      var mkSel = function (opts, val, on) {
        var s = el('select', { class: 'arcp-select' });
        opts.forEach(function (o) { s.appendChild(el('option', { value: String(o[0]), text: o[1] })); });
        s.value = String(val);
        s.addEventListener('change', function () { on(s.value); sync(); });
        return s;
      };
      rescaleRow = el('div', { class: 'arcp-scale arcp-rescale' }, [
        el('span', { class: 'arcp-scale__label', text: 'Written for ' + pb.layers + ' \u00d7 ' + sizeLabel(pb.d) + ' ' + pb.shape + ' \u2014 rescale to my pans:' }),
        mkSel(DIAMETERS.map(function (n) { return [n, sizeLabel(n)]; }), sel.d, function (v) { sel.d = +v; }),
        mkSel([['round', 'Round'], ['square', 'Square']], sel.shape, function (v) { sel.shape = v; }),
        mkSel([[1, '1 layer'], [2, '2 layers'], [3, '3 layers'], [4, '4 layers'], [5, '5 layers'], [6, '6 layers']], sel.layers, function (v) { sel.layers = +v; })
      ]);
    } else {
      /* batch recipes: segmented \u00bd / \u00d71 / \u00d72 / \u00d73 + custom, in the strip */
      var seg = el('div', { class: 'arcp-seg', role: 'group', 'aria-label': 'Scale' });
      var customInput = el('input', { class: 'learn-input arcp-seg__custominput', type: 'number',
        min: '0.1', step: '0.05', inputmode: 'decimal', placeholder: '\u00d7 ?', 'aria-label': 'Custom scale factor' });
      customInput.hidden = true;
      var clearSeg = function () {
        Array.prototype.forEach.call(seg.children, function (b) { b.classList.remove('is-active'); });
      };
      var setFactor = function (f, fromSeg) {
        factor = f;
        if (fromSeg) customInput.value = '';
        trackUsed();
        renderIngs();
      };
      [[0.5, '\u00bd'], [1, '\u00d7 1'], [2, '\u00d7 2'], [3, '\u00d7 3']].forEach(function (s) {
        var b = el('button', { class: 'arcp-seg__btn' + (s[0] === 1 ? ' is-active' : ''),
          type: 'button', 'data-f': String(s[0]), text: s[1] });
        b.addEventListener('click', function () {
          clearSeg(); b.classList.add('is-active'); setFactor(s[0], true);
        });
        seg.appendChild(b);
      });
      var customToggle = el('button', { class: 'arcp-seg__customtoggle', type: 'button',
        'aria-expanded': 'false', text: 'custom \u25be' });
      customToggle.addEventListener('click', function () {
        customInput.hidden = !customInput.hidden;
        customToggle.setAttribute('aria-expanded', customInput.hidden ? 'false' : 'true');
        if (!customInput.hidden) customInput.focus();
      });
      customInput.addEventListener('input', function () {
        var v = parseFloat(customInput.value);
        if (isFinite(v) && v > 0) { clearSeg(); setFactor(v, false); }
      });
      scaleCell.appendChild(el('div', { class: 'arcp-open__scale' }, [
        seg,
        el('span', { class: 'arcp-seg__custom' }, [customToggle, customInput])
      ]));
    }
    head.appendChild(strip);
    if (rescaleRow) head.appendChild(rescaleRow);

    /* -- delete confirm (explicit, yours only) -- */
    var confirmBar = null;
    if (isMine) {
      var confirmDel = el('button', { class: 'ld-btn ld-btn--primary arcp-open__confirmdel', type: 'button', text: 'Delete' });
      var confirmKeep = el('button', { class: 'ld-btn ld-btn--secondary', type: 'button', text: 'Keep it' });
      confirmBar = el('div', { class: 'arcp-open__confirm' }, [
        el('span', { class: 'arcp-open__confirmtxt', text: 'Delete this recipe? This can\u2019t be undone.' }),
        el('div', { class: 'arcp-open__confirmbtns' }, [confirmDel, confirmKeep])
      ]);
      confirmBar.hidden = true;
      confirmKeep.addEventListener('click', function () { confirmBar.hidden = true; });
      confirmDel.addEventListener('click', function () {
        mine.items = mine.items.filter(function (x) { return x.id !== r.id; });
        writeMine();
        if (editingId === r.id && editorSheet) { editorSheet.close(); editingId = null; }
        closeRecipe();
        renderLibrary();
      });
    }

    /* -- body -- */
    var body = el('div', { class: 'arcp-open__body' });
    body.appendChild(el('div', { class: 'arcp-subrule' }, [
      el('span', { class: 'arcp-subrule__lbl subheading', text: 'Ingredients' }),
      el('span', { class: 'arcp-subrule__line', 'aria-hidden': 'true' })
    ]));
    body.appendChild(ingList);
    body.appendChild(cautionBox);
    if (r.method && r.method.length) {
      body.appendChild(el('div', { class: 'arcp-subrule' }, [
        el('span', { class: 'arcp-subrule__lbl subheading', text: 'Method' }),
        el('span', { class: 'arcp-subrule__line', 'aria-hidden': 'true' })
      ]));
      body.appendChild(el('ol', { class: 'arcp-method' },
        r.method.map(function (s) { return el('li', { text: s }); })));
    }
    if (r.tips && r.tips.length) {
      body.appendChild(el('div', { class: 'arcp-inset' }, [
        el('span', { class: 'arcp-inset__lbl', text: 'Chef\u2019s notes' }),
        el('span', {}, r.tips.map(function (t, i) { return el('span', { text: (i ? ' ' : '') + t }); }))
      ]));
    }
    if (r.storage) {
      body.appendChild(el('div', { class: 'arcp-inset' }, [
        el('span', { class: 'arcp-inset__lbl', text: 'Storage' }),
        el('span', { text: r.storage })
      ]));
    }
    if (r.pairsWith && r.pairsWith.length) {
      var pairs = el('div', { class: 'arcp-pairs' }, [el('span', { class: 'arcp-pairs__label', text: 'Pairs with' })]);
      r.pairsWith.forEach(function (name) {
        var targetId = recipeByTitle[name.toLowerCase()];
        var target = null;
        if (targetId && DATA) DATA.recipes.some(function (x) { if (x.id === targetId) { target = x; return true; } return false; });
        if (target) {
          pairs.appendChild(el('a', {
            class: 'arcp-pair arcp-pair--link', href: '#', text: name,
            onclick: function (ev) { ev.preventDefault(); openRecipe(target, false); }
          }));
        } else {
          pairs.appendChild(el('span', { class: 'arcp-pair', text: name }));
        }
      });
      body.appendChild(pairs);
    }

    /* -- the library-to-file bridge, then the quiet action links -- */
    var clientRow = clientAddBtn(r);
    var copy = el('button', { class: 'arcp-foot__link', type: 'button', text: 'Copy recipe' });
    copy.addEventListener('click', function () { doCopy(copyText(r, factor), copy, 'Copied!', 'Copy recipe'); });
    var bm = el('button', { class: 'arcp-foot__link', type: 'button', text: 'Batch Math \u2192' });
    var foot = el('div', { class: 'arcp-open__foot' });
    bm.addEventListener('click', function () {
      var result = addToPlan(r, factor, pb, sel);
      trackCta('batch_math');
      bm.textContent = result === 'ok' ? 'Added \u2713' :
        result === 'full' ? 'Make list is full (30)' : 'Couldn\u2019t save';
      setTimeout(function () { bm.textContent = 'Batch Math \u2192'; }, 1800);
      if (result === 'ok' && !foot.querySelector('.arcp-plan__hint')) {
        /* redesign r2: #dayplan was retired 2026-07-15 — a dead anchor that
           now also fails the tab lookup; land on the page itself */
        foot.appendChild(el('a', { class: 'arcp-plan__hint', href: '/pages/batch-math',
          text: 'It\u2019s waiting in Batch Math \u2192 today\u2019s make list' }));
      }
    });
    var planner = el('a', { class: 'arcp-foot__link', href: '/pages/planner', text: 'Use in Planner \u2192' });
    planner.addEventListener('click', function () { trackCta('planner'); });
    foot.appendChild(copy); foot.appendChild(bm); foot.appendChild(planner);

    card.appendChild(head);
    if (confirmBar) card.appendChild(confirmBar);
    card.appendChild(body);
    if (clientRow) card.appendChild(el('div', { class: 'arcp-open__client' }, [clientRow]));
    card.appendChild(foot);
    wrap.appendChild(card);
    wrap.appendChild(noteBox);

    renderIngs();
    return wrap;
  }

  /* ============================================================
     SHEETS (r182) — the design's two presentations, one shell.
     'full'   : the add-recipe form and the signature builder.
     'bottom' : the recipe picker and the tier picker (70vh, drag
                handle, slide-up 280ms).
     The Shopify theme header outranks any modest z-index, so these
     sit at 95/97 — above the PWA tab bar (70) and the settings
     modal (90), the only fixed things in the suite.
     ============================================================ */
  var sheetStack = [];
  function lockScroll(on) {
    try { document.documentElement.classList.toggle('arcp-noscroll', !!on); } catch (e) { }
  }
  function makeSheet(kind) {
    var body = el('div', { class: 'arcp-sheet__body' });
    var head = el('div', { class: 'arcp-sheet__head' });
    var panel = el('div', { class: 'arcp-sheet__panel arcp-sheet__panel--' + kind, role: 'dialog',
      'aria-modal': 'true', tabindex: '-1' });
    if (kind === 'bottom') panel.appendChild(el('span', { class: 'arcp-sheet__grip', 'aria-hidden': 'true' }));
    panel.appendChild(head);
    panel.appendChild(body);
    var root = el('div', { class: 'arcp-sheet arcp-sheet--' + kind + (sheetStack.length ? ' is-stacked' : '') }, [panel]);
    var api = {
      root: root, head: head, body: body, panel: panel,
      close: function () {
        var i = sheetStack.indexOf(api);
        if (i === -1) return;
        sheetStack.splice(i, 1);
        root.classList.remove('is-open');
        setTimeout(function () { if (root.parentNode) root.parentNode.removeChild(root); }, 240);
        if (!sheetStack.length) lockScroll(false);
        if (api.onClose) api.onClose();
      },
      open: function () {
        document.body.appendChild(root);
        sheetStack.push(api);
        lockScroll(true);
        /* commit the closed state before flipping it, so the slide-up has
           somewhere to move from - a forced reflow, not a frame, because a
           backgrounded tab never paints one */
        void root.offsetHeight;
        root.classList.add('is-open');
        try { panel.focus({ preventScroll: true }); } catch (e) { }
        return api;
      }
    };
    root.addEventListener('click', function (ev) { if (ev.target === root) api.close(); });
    root.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') api.close(); });
    return api;
  }
  /* the full-screen sheet's Cancel / TITLE / action bar */
  function fullSheetHead(sh, title, actionLabel, onAction) {
    var cancel = el('button', { class: 'arcp-sheet__cancel', type: 'button', text: 'Cancel' });
    cancel.addEventListener('click', function () { sh.close(); });
    var act = el('button', { class: 'arcp-sheet__act', type: 'button', text: actionLabel });
    act.addEventListener('click', onAction);
    sh.head.appendChild(cancel);
    sh.head.appendChild(el('span', { class: 'arcp-sheet__title', text: title }));
    sh.head.appendChild(act);
    return act;
  }

  /* ---------- the library accordion (r182 "Combos on top") ----------
     Collapsed category rows, the category name said ONCE on its header,
     recipes as indented list rows underneath. ONE accordion serves both
     scopes — "your recipes" and, for Academy, the studio library — so the
     page no longer ships a second full copy of every category. ---------- */
  var libScopeEl, libAccEl, libCountEl, libFootEl;

  /* The design shortens the two long labels for a phone: a tracked
     11.5px cap line has to survive at 375px without wrapping to two
     lines, which is what "JELLIES, COMPOTES, CURDS & CARAMELS" did. The
     master's full labels still name the categories everywhere else
     (the add form's chips, the open recipe's eyebrow). */
  var CAT_SHORT = {
    bases: 'Cake bases',
    montees: 'Montées',
    cremeux: 'Crémeux & ganache',
    jellies: 'Jellies & compotes',
    finishes: 'Buttercreams & finishes',
    other: 'Soaks & extras'
  };
  function catShort(c) {
    return CAT_SHORT[c.id] || (c.label || '').split(' · ')[0];
  }

  function accGroup(cat, recs) {
    var id = cat.id;
    var isOpen = !!expanded[id] && recs.length > 0;
    var head = el('button', {
      class: 'arcp-cat' + (isOpen ? ' is-open' : '') + (recs.length ? '' : ' is-empty'),
      type: 'button', 'aria-expanded': isOpen ? 'true' : 'false'
    }, [
      el('span', { class: 'arcp-cat__lbl', text: catShort(cat) }),
      el('span', { class: 'arcp-cat__right' }, [
        el('span', { class: 'arcp-cat__n', text: String(recs.length) }),
        el('span', { class: 'arcp-cat__chev', 'aria-hidden': 'true' })
      ])
    ]);
    var rows = el('div', { class: 'arcp-cat__rows' });
    recs.forEach(function (x) { rows.appendChild(libRow(x.r, x.isMine)); });
    var panel = el('div', { class: 'arcp-cat__panel' + (isOpen ? ' is-open' : '') }, [rows]);
    if (isOpen) panel.style.maxHeight = 'none';
    head.addEventListener('click', function () {
      if (!recs.length) return;                      /* an empty category never expands */
      var nowOpen = !head.classList.contains('is-open');
      expanded[id] = nowOpen;
      saveExpanded();
      head.classList.toggle('is-open', nowOpen);
      head.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
      var reduced = false;
      try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { }
      if (reduced) {
        panel.classList.toggle('is-open', nowOpen);
        panel.style.maxHeight = nowOpen ? 'none' : '';
        return;
      }
      if (nowOpen) {
        panel.classList.add('is-open');
        panel.style.maxHeight = rows.scrollHeight + 'px';
        /* released to auto once the animation is done, so a row that
           wraps to two lines later is never clipped */
        setTimeout(function () {
          if (panel.classList.contains('is-open')) panel.style.maxHeight = 'none';
        }, 300);
      } else {
        /* requestAnimationFrame does NOT fire in a backgrounded tab, and a
           collapse that never runs leaves the panel stuck open. Committing
           the start value with a forced reflow is synchronous and always
           lands. */
        panel.style.maxHeight = rows.scrollHeight + 'px';
        void panel.offsetHeight;
        panel.classList.remove('is-open');
        panel.style.maxHeight = '';
      }
    });
    return el('div', { class: 'arcp-accgrp' }, [head, panel]);
  }
  /* a gold divider inside a list, matching the picker sheet's
     (2026-09-14: dropped the ✦ ornament - calm-minimal is hairlines) */
  function goldDivider(text) {
    return el('div', { class: 'arcp-golddiv' }, [
      el('span', { class: 'arcp-golddiv__lbl', text: text }),
      el('span', { class: 'arcp-golddiv__rule', 'aria-hidden': 'true' })
    ]);
  }

  function setScope(next) {
    if (scope === next) return;
    scope = next;
    renderLibrary();
    if (libScopeEl) ldNav(libScopeEl);
  }

  function renderLibrary() {
    var n = mine.items.length;
    /* r53/r56: the cap is stated where it bites — adding. A device can
       legitimately hold MORE than the free cap (a lapsed Pro's synced
       box), so over the cap the line states the facts instead. */
    if (libCountEl) libCountEl.textContent = MINE_PRO
      ? n + ' of ' + MINE_MAX + ' saved'
      : (n > MINE_MAX
        ? n + ' saved · all usable · adding more needs Pro'
        : n + ' of ' + MINE_MAX + ' free recipe slots' + (n >= MINE_MAX ? ' · full' : ''));

    if (libScopeEl) {
      clearNode(libScopeEl);
      if (scope === 'studio') {
        var back = el('button', { class: 'arcp-scope__back', type: 'button' }, [
          el('span', { class: 'arcp-scope__chev', 'aria-hidden': 'true', text: '‹' }),
          el('span', { text: 'YOUR RECIPES' })
        ]);
        back.addEventListener('click', function () { setScope('mine'); });
        libScopeEl.appendChild(back);
        libScopeEl.appendChild(el('span', { class: 'arcp-scope__studio is-here',
          text: 'STUDIO LIBRARY' }));
      } else {
        libScopeEl.appendChild(el('span', { class: 'arcp-scope__mine',
          text: 'YOUR RECIPES · ' + n }));
        var studioLink = el('button', { class: 'arcp-scope__studio', type: 'button',
          text: 'STUDIO LIBRARY ›' });
        studioLink.addEventListener('click', function () {
          if (IS_ACADEMY) { setScope('studio'); return; }
          /* below Academy there is nothing to scope to — the destination is
             the enrolment panel the template already renders, which carries
             the right CTA wording and the right URL for the season */
          var lock = document.querySelector('.arcp-studio-lock, .arcp-enrol');
          if (lock) ldNav(lock);
        });
        libScopeEl.appendChild(studioLink);
      }
    }
    clearNode(libAccEl);
    if (libFootEl) libFootEl.hidden = scope === 'studio';

    /* ---- r39: an empty box during a pending pull is NOT "you have none" ---- */
    if (scope === 'mine' && !n) {
      var sy = null;
      try { sy = window.LAYERD && window.LAYERD.cloudSync && window.LAYERD.cloudSync.status(); } catch (e) { }
      if (sy && sy.enabled !== false && !sy.lastPull) {
        libAccEl.appendChild(el('div', { class: 'arcp-syncwait', role: 'status' }, [
          el('span', { class: 'arcp-syncwait__t', text: 'Loading your recipes from your account…' }),
          el('span', { class: 'arcp-syncwait__s', text: 'Nothing is missing. This page has not finished checking your account yet. Recipes are never deleted by syncing.' })
        ]));
        return;
      }
      if (sy && sy.enabled === false) {
        libAccEl.appendChild(el('div', { class: 'arcp-syncwait arcp-syncwait--off', role: 'status' }, [
          el('span', { class: 'arcp-syncwait__t', text: 'Not signed in. Showing this device only' }),
          el('span', { class: 'arcp-syncwait__s', text: 'Any recipes saved to your account are safe; sign in and they come back. Nothing here has been deleted.' })
        ]));
        return;
      }
    }

    var shown = 0;
    /* 2026-09-14: the free sample leads Your recipes as its FIRST row, tagged
       "sample" (was a ✦ gold divider + card at the foot, which a new visitor
       reached only after scrolling past six empty category rows). It is
       LAYER'D's, not hers, so it still sits OUTSIDE the category groups and
       does not inflate the "YOUR RECIPES · N" count. An Academy member already
       has it inside the studio scope (one of DATA.recipes), so it is not
       repeated there. */
    if (scope === 'mine' && !IS_ACADEMY) {
      var samp = SAMPLES.filter(matches);
      if (samp.length) {
        shown += samp.length;   /* keeps the "+ Add your first recipe" empty-state from showing under the sample */
        var srows = el('div', { class: 'arcp-cat__rows is-flat arcp-samplerows' });
        samp.forEach(function (r) { srows.appendChild(libRow(r, false, true)); });
        libAccEl.appendChild(srows);
      }
    }
    /* search drives the accordion: matching categories open themselves,
       non-matching ones collapse and hide, counts become match counts */
    CATS.forEach(function (c) {
      var recs = [];
      if (scope === 'studio') {
        (DATA ? DATA.recipes : []).forEach(function (r) {
          if (r.category === c.id && matches(r)) recs.push({ r: r, isMine: false });
        });
      } else {
        mine.items.forEach(function (r) {
          if (r.category === c.id && matches(r)) recs.push({ r: r, isMine: true });
        });
      }
      if (filter.q) {
        if (!recs.length) return;
        expanded[c.id] = true;
      }
      shown += recs.length;
      libAccEl.appendChild(accGroup(c, recs));
    });

    if (scope === 'mine') {
      var known = {};
      CATS.forEach(function (c) { known[c.id] = true; });
      var orecs = [];
      mine.items.forEach(function (r) {
        if (!known[r.category] && matches(r)) orecs.push({ r: r, isMine: true });
      });
      if (orecs.length) {
        if (filter.q) expanded.__other = true;
        shown += orecs.length;
        libAccEl.appendChild(accGroup({ id: '__other', label: 'Other' }, orecs));
      }
    }

    if (!shown) {
      if (filter.q) {
        libAccEl.appendChild(el('p', { class: 'arcp-empty', text:
          'No recipes match “' + search.value.trim() + '”.' }));
      } else if (scope === 'mine') {
        var inviteBtn = el('button', { class: 'arcp-invite__btn', type: 'button',
          text: '+ Add your first recipe' });
        inviteBtn.addEventListener('click', function () { openAddSheet(); });
        libAccEl.appendChild(el('div', { class: 'arcp-invite' }, [inviteBtn]));
      } else {
        libAccEl.appendChild(el('p', { class: 'arcp-empty', text: 'Nothing here yet.' }));
      }
    }
  }

  function buildMineSection() {
    var sec = el('section', { class: 'arcp-section arcp-box arcp-lib2' + (IS_ACADEMY ? ' arcp-box--academy' : '') });
    /* r57 (Mariya): the display gate. A logged-out browser on a device
       whose recipe box has synced with an account shows a login card, not
       the recipes — the "19 of 3 free slots" screenshot was her own Pro
       box rendering on the free branch. Never-synced visitors (the
       three-slot funnel) have no sync footprint and are never gated. */
    if (window.LdCakeFile && window.LdCakeFile.displayGated && window.LdCakeFile.displayGated() && readMine().items.length) {
      sec.appendChild(el('div', { class: 'arcp-syncwait arcp-syncwait--off', role: 'status' }, [
        el('span', { class: 'arcp-syncwait__t', text: 'Logged out. Your recipes are hidden on this device' }),
        el('span', { class: 'arcp-syncwait__s', text: 'Nothing has been deleted. Log in and your recipe box comes right back.' }),
        el('a', { class: 'learn-btn arcp-gatelogin',
          href: '/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname + location.search),
          text: 'Log in' })
      ]));
      return sec;
    }
    var dl = buildVocabDatalist();
    if (dl) sec.appendChild(dl);

    mineListWrap = el('div', { class: 'arcp-box__list' });

    /* ---- 1. the search + add row ----------------------------------
       A 42px field beside a 42px circle in the design; the README's own
       note says to grow BOTH where the codebase enforces a minimum, and
       the suite's --hit is 44px, so both are 44 and still equal. Units
       and "Download a backup" are deliberately NOT here: Toolkit Settings
       already owns 'layerd-learn-units' and Export/Restore for every
       tool, and two controls for one preference is how they drift. ---- */
    var addBtn = el('button', { class: 'arcp-addbtn', type: 'button',
      'aria-label': 'Add a recipe', title: 'Add a recipe' });
    addBtn.appendChild(el('span', { class: 'arcp-addbtn__g', 'aria-hidden': 'true', text: '+' }));
    addBtn.addEventListener('click', function () { openAddSheet(); });
    mineListWrap.appendChild(el('div', { class: 'arcp-topbar' }, [
      el('div', { class: 'arcp-searchwrap' }, [
        el('span', { class: 'arcp-searchwrap__g', 'aria-hidden': 'true' }),
        search
      ]),
      addBtn
    ]));

    /* ---- 2. the signature shelf -----------------------------------
       (the combos section already rendered into #arcpCombos; adopt the
       live node, listeners and all)
       2026-09-14: a signature pairs recipes, so it's a feature for people
       who HAVE recipes. It used to lead the screen as an empty carousel for
       a brand-new visitor. Now it only shows once there are 2+ recipes (or
       the visitor already built a signature, so we never hide their work) -
       an engaged user's signatures still lead, an empty one no longer does. ---- */
    var cm = document.getElementById('arcpCombos');
    if (cm) {
      var _mineN = readMine().items.length, _comboN = 0;
      try { var _mv = JSON.parse(localStorage.getItem('layerd-academy-my-combos')); if (_mv && _mv.combos) _comboN = _mv.combos.length; } catch (e) { }
      if (_mineN >= 2 || _comboN > 0) mineListWrap.appendChild(cm);
      else cm.hidden = true;
    }

    /* ---- 3. the library: scope bar, accordion, a quiet foot ---- */
    libScopeEl = el('div', { class: 'arcp-scope' });
    libAccEl = el('div', { class: 'arcp-acc' });
    libCountEl = el('span', { class: 'arcp-slotline' });
    libFootEl = el('div', { class: 'arcp-libfoot' }, [libCountEl]);
    /* r178: the Pro offer as an offer, not a number tacked onto a status
       line. It reads the same at 0 recipes as at 3 — an invitation, not a
       punishment that appears at the cap. */
    if (!MINE_PRO) {
      /* 2026-09-14: was a gold-bordered card with a 34px "100" (and a Georgia
         numeral). The brief: Pro is a one-line slot note with a door. Now a
         quiet hairline line + a gold text-door to the PRODUCT page (was
         /pages/toolkit, the marketing landing - wrong). */
      libFootEl.appendChild(el('p', { class: 'arcp-proslots' }, [
        el('span', { class: 'arcp-proslots__t', text: 'Toolkit Pro saves 100 recipes, costed and synced to every device. ' }),
        el('a', { class: 'arcp-proslots__go', href: '/products/learn-hub-pro', text: 'See Pro →' })
      ]));
    }
    mineListWrap.appendChild(el('div', { class: 'arcp-lib' }, [libScopeEl, libAccEl, libFootEl]));

    /* ----- open view: a single recipe replaces the list while shown ----- */
    mineOpenWrap = el('div', { class: 'arcp-box__open' });
    mineOpenWrap.hidden = true;

    sec.appendChild(mineListWrap);
    sec.appendChild(mineOpenWrap);
    renderLibrary();

    /* r187 (Mariya: "the free layer'd recipe is duplicated. It should
       only show once"). Below Academy the accordion renders the sample
       as a real row under the gold marker, AND the template still
       carries the server-rendered card below the library - the
       crawlable, no-JS copy. Two copies on one screen is one too many:
       when the row renders, the card and its section head hide. They
       stay in the raw HTML on purpose (crawlers and no-JS visitors keep
       a complete recipe), and the card's #arcp-sample-<id> deep links
       reroute to the interactive open view instead of a hidden card. */
    if (!IS_ACADEMY && SAMPLES.length) {
      Array.prototype.forEach.call(document.querySelectorAll('.arcp-sample'), function (card) {
        card.hidden = true;
        var head = card.previousElementSibling;
        if (head && head.className.indexOf('arcp-sechead') !== -1) head.hidden = true;
      });
      if (location.hash.indexOf('#arcp-sample-') === 0) {
        var wantId = location.hash.slice('#arcp-sample-'.length);
        for (var si = 0; si < SAMPLES.length; si++) {
          if (String(SAMPLES[si].id) === wantId) {
            (function (r) { setTimeout(function () { openRecipe(r, false); }, 160); })(SAMPLES[si]);
            break;
          }
        }
      }
    }
    return sec;
  }

  /* r182: the page's own inches/cm toggle is gone — Toolkit Settings owns
     'layerd-learn-units' for every tool, and two controls for one preference
     is how they drift. A change made there (or in another tab) still
     re-labels the pan sizes here, so the two never disagree. */
  function onUnitsChange() {
    if (currentOpen) openRecipe(currentOpen.r, currentOpen.isMine);
    else renderLibrary();
  }
  var unitsWas = unitPref();
  function maybeUnits() {
    var now = unitPref();
    if (now === unitsWas) return;
    unitsWas = now;
    onUnitsChange();
  }
  window.addEventListener('storage', maybeUnits);
  window.addEventListener('layerd:cake-updated', maybeUnits);

  /* ---------- Signature Combinations + the client bridge (2026-07-16) ----------
     Mariya: assign flavours straight from the library. Combos render from the
     same FREE definitions the Planner ships; "Assign to [client]" writes the
     Planner's exact comboAssignments snapshot + the tier's flavour, and
     recipe cards gain "Add to [client]'s components". Everything goes through
     the cake-file layer's normalized store and announces itself, so the
     pipeline bar, chips and an open Planner tab update live. */
  (function combosBridge() {
    var cMount = document.getElementById('arcpCombos');
    if (!cMount) return;
    /* r57: signature combos sync with the account too — the display gate
       covers them the same way it covers the recipes above. */
    if (window.LdCakeFile && window.LdCakeFile.displayGated && window.LdCakeFile.displayGated()) return;
    var COMBOS = [];
    try { var ci = document.getElementById('arcp-combos'); COMBOS = ci ? JSON.parse(ci.textContent) : []; } catch (e) { COMBOS = []; }
    var MYC = [];
    try {
      var mv = JSON.parse(localStorage.getItem('layerd-academy-my-combos'));
      if (mv && mv.v === 1 && Object.prototype.toString.call(mv.combos) === '[object Array]') MYC = mv.combos;
    } catch (e) { }
    /* Combos v2 (2026-07-20): this section is the ONE home for building,
       editing and deleting signature combos — even when both lists start
       empty. Studio presets (the island) are an Academy benefit; Pro pages
       don't ship the island at all. */
    function saveMyc() {
      try { localStorage.setItem('layerd-academy-my-combos', JSON.stringify({ v: 1, combos: MYC })); } catch (e) { }
      announce();
    }
    function newComboId() { return 'mine:' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }
    function activeB() { return (window.LdCakeFile && window.LdCakeFile.getActiveBooking) ? window.LdCakeFile.getActiveBooking() : null; }
    function fillingLine(c) {
      return (c.components || []).filter(function (k) { return k.category !== 'bases'; })
        .map(function (k) { return k.label; }).join(' \u00b7 ');
    }
    function announce() {
      try { window.dispatchEvent(new CustomEvent('layerd:cakefile', { detail: { type: 'file', source: 'recipes' } })); } catch (e) { }
      try { window.dispatchEvent(new Event('layerd:cake-updated')); } catch (e) { }
    }
    function mutateStore(fn) {
      if (!window.LdCakeFile || !window.LdCakeFile.readStore) return false;
      var store = window.LdCakeFile.readStore();
      fn(store);
      try { localStorage.setItem('layerd-academy-bookings', JSON.stringify(store)); } catch (e) { return false; }
      announce();
      return true;
    }
    /* ---- r12 (Mariya, 2026-07-31) — the assignment bug ----
       Three complaints, one root each:
       * "I cannot unselect once I select a flavour by mistake" — every
         tier chip assigned, including one already assigned. There was no
         inverse. clearComboFrom() is it.
       * "it lets me select multiple flavours for a single tier" — the
         DATA was always one combo per tier (this overwrites the slot),
         but only the picker you clicked was redrawn, so a picker left
         open on another combo kept its stale tick. refreshOpenTierPicks()
         redraws every open one.
       * assign and clear must never drift apart, so the component resync
         lives in one function both call. */
    function syncComboComponents(b) {
      b.components = b.components || [];
      var assigned = {};
      (b.comboAssignments || []).forEach(function (a) { if (a && a.comboId) assigned[a.comboId] = true; });
      /* 2026-08-03: a hand-typed batch count outlives the combo that carried
         it — replacing a combo drops its rows and they are recreated below,
         which was silently discarding her number. Mirrors the Planner's copy. */
      var typedKeep = {};
      b.components.forEach(function (c) {
        if (!c.batchesSet || c.batches == null) return;
        typedKeep[((c.name || '') + '').toLowerCase() + '|' + (c.category || '')] = c.batches;
      });
      b.components = b.components.filter(function (c) {
        if (!c.fromCombo) return true;
        return assigned[c.fromCombo] && c.category !== 'bases';
      });
      (b.comboAssignments || []).forEach(function (a) {
        if (!a) return;
        (a.components || []).forEach(function (k) {
          if ((k.category || 'bases') === 'bases') return;
          /* Mariya, 2026-08-03 — the stale typed-component bug. Full
             explanation in learn-timeline-hub.js's copy of this function;
             the two MUST stay identical. In short: a boolean `exists` let a
             LINKED combo entry match an UNLINKED row of the same name and
             skip creating the linked one, so a combo rebuilt from saved
             recipes could never replace the typed version it succeeded, and
             the rows stayed permanently unquantified. Upgrade in place. */
          var match = null;
          for (var mi = 0; mi < b.components.length; mi++) {
            var c = b.components[mi];
            if (k.recipeId && c.recipeId) { if (c.recipeId === k.recipeId) { match = c; break; } continue; }
            if (!!c.fromCombo && (c.name || '') === (k.label || '') && c.category === k.category) { match = c; break; }
          }
          if (match) {
            if (k.recipeId && !match.recipeId) {
              match.recipeId = k.recipeId;
              match.fromCombo = a.comboId;
              if (!match.batchesSet) { match.batches = null; match.batchesAuto = true; }
            }
            return;
          }
          /* created UNSET, never 1 — a fabricated quantity reads exactly
             like a real one (matches the Planner's copy) */
          var row = { name: k.label || '', category: k.category || 'bases',
            recipeId: k.recipeId || null, batches: null, batchesAuto: true, fromCombo: a.comboId };
          var keptN = typedKeep[((row.name || '') + '').toLowerCase() + '|' + (row.category || '')];
          if (keptN != null) { row.batches = keptN; row.batchesSet = true; delete row.batchesAuto; }
          b.components.push(row);
        });
      });
    }
    function withBooking(bId, fn) {
      return mutateStore(function (store) {
        for (var i = 0; i < store.bookings.length; i++) {
          var b = store.bookings[i];
          if (b.id !== bId) continue;
          b.comboAssignments = b.comboAssignments || [];
          while (b.comboAssignments.length < (b.tierSpec || []).length) b.comboAssignments.push(null);
          fn(b);
          b.cake = { updatedAt: Date.now(), updatedBy: 'recipes' };
          syncComboComponents(b);
        }
      });
    }
    function assignComboTo(bId, tierIdx, combo, done) {
      var ok = withBooking(bId, function (b) {
        /* the Planner's exact snapshot shape (assignCombo) */
        b.comboAssignments[tierIdx] = { comboId: combo.id, name: combo.name,
          components: JSON.parse(JSON.stringify(combo.components || [])), at: Date.now() };
        if (b.tierSpec && b.tierSpec[tierIdx]) b.tierSpec[tierIdx].flavour = combo.name;
      });
      if (done) done.textContent = ok ? 'Assigned \u2713 \u2014 the Planner picks it up' : 'Couldn\u2019t save \u2014 try again';
      renderAssignSummary();
      refreshOpenTierPicks();
    }
    function clearComboFrom(bId, tierIdx, done) {
      var ok = withBooking(bId, function (b) {
        b.comboAssignments[tierIdx] = null;
        if (b.tierSpec && b.tierSpec[tierIdx]) b.tierSpec[tierIdx].flavour = '';
      });
      if (done) done.textContent = ok ? 'Cleared \u2014 that tier has no flavour yet' : 'Couldn\u2019t save \u2014 try again';
      renderAssignSummary();
      refreshOpenTierPicks();
    }
    /* ============================================================
       r182 "Combos on top" — the signature shelf, the tier sheet and
       the slot builder.

       What moved: the combos are no longer a grid two screens down
       under an explanatory paragraph. They lead the tab as a
       horizontally-swipeable shelf whose every card carries the one
       action that matters — ASSIGN TO A TIER. The page-level tier
       summary card is gone from the landing; its rows, its faux
       toggles and its "N tiers still need a flavour" warning all
       moved INTO the assign sheet, which is where you act on them.
       Nothing was dropped: same store, same snapshot shape, same
       Planner handoff.
       ============================================================ */

    /* every component, bases included — the fillings-only line made a
       saved base cake look lost (Mariya, 2026-07-20) */
    function componentLine(c) {
      return (c.components || []).map(function (k) { return k.label; }).join(' · ');
    }

    /* ---------- the tier sheet ----------
       One bottom sheet: pick the tier, see every other tier's flavour,
       flip a tier to faux, and read the completeness warning — the four
       things the old always-on summary card did, now behind the action
       that needs them. */
    var assignSheet = null, assignCombo = null;

    /* the status line is created ONCE per sheet and re-appended on every
       redraw: assignComboTo() writes into it and then triggers the redraw,
       so a fresh node each time would swallow "Couldn't save - try again"
       exactly when it matters. */
    function tierSheetBody(box, c, done) {
      clearNode(box);
      var fresh = activeB();
      if (!fresh) { box.appendChild(el('p', { class: 'arcp-tsheet__none', text: 'No client file open.' })); return; }
      var spec = window.LdCakeFile.specOf(fresh);
      var asg = fresh.comboAssignments || [];
      if (!spec.length) {
        box.appendChild(el('p', { class: 'arcp-tsheet__none', text: 'No tiers on this file yet. Size the cake first.' }));
      }
      spec.forEach(function (t, i) {
        var cur = asg[i];
        var isThis = !!(cur && c && cur.comboId === c.id);
        var row = el('div', { class: 'arcp-trow' + (t.faux ? ' is-faux' : (isThis ? ' is-on' : '')) });
        var pick = el('button', {
          class: 'arcp-trow__pick', type: 'button',
          'aria-pressed': isThis ? 'true' : 'false',
          title: t.faux ? 'A faux tier is never baked or filled'
            : (isThis ? 'Tap to clear this tier' : (cur ? 'Currently ' + cur.name + ' · tap to replace' : 'Tap to assign'))
        }, [
          el('span', { class: 'arcp-trow__body' }, [
            el('span', { class: 'arcp-trow__t', text: 'Tier ' + (i + 1) + ' · ' + t.d + '″' }),
            el('span', { class: 'arcp-trow__s', text: t.faux
              ? 'faux tier · no flavour needed'
              : (cur ? cur.name : (((t.flavour || '').trim()) || 'no flavour yet')) })
          ]),
          el('span', { class: 'arcp-tick' + (isThis ? ' is-on' : ''), 'aria-hidden': 'true' })
        ]);
        pick.disabled = !!t.faux;
        pick.addEventListener('click', function () {
          if (!c) return;
          /* r12: a tap on the tier that already holds THIS signature takes
             it off. Anything else assigns, replacing whatever was there —
             a tier holds exactly one flavour. */
          if (isThis) clearComboFrom(fresh.id, i, done);
          else assignComboTo(fresh.id, i, c, done);
        });
        row.appendChild(pick);
        /* r42: a faux tier is a dummy — never baked or filled, so asking it
           for a flavour is meaningless. The row says so and offers the way back. */
        var tog = el('button', { class: 'arcp-fauxtog', type: 'button',
          text: t.faux ? 'make it real' : 'mark as faux',
          title: t.faux
            ? 'Bake and fill this tier after all'
            : 'A dummy tier: sanded, sealed and covered, never baked. It leaves the servings and the batch counts, and gets its own early tasks in the Planner.' });
        tog.addEventListener('click', function () { setFaux(fresh.id, i, !t.faux); });
        row.appendChild(tog);
        box.appendChild(row);
      });
      /* 2026-08-12 (Mariya): "there should be a rule where you get some type
         of warning ... until you assign all flavours to tiers so nothing is
         missed by accident which can ruin the production schedule."
         It names the tiers — "2 tiers still need a flavour" alone sends her
         back to count. Faux tiers are never counted. It clears itself the
         moment the last tier is assigned and turns into the go-ahead. */
      var missing = (window.LdCakeFile.predicates &&
        window.LdCakeFile.predicates.tiersMissingFlavour(fresh)) || [];
      var real = spec.filter(function (t) { return !t.faux; }).length;
      if (real > 0) {
        if (missing.length) {
          box.appendChild(el('p', { class: 'arcp-tsheet__warn', role: 'status' }, [
            el('strong', { text: missing.length === 1
              ? '1 tier still needs a flavour' : missing.length + ' tiers still need a flavour' }),
            el('span', { text: ' · ' + missing.map(function (m) { return m.label; }).join(', ')
              + '. The Planner builds the bake schedule from these, so an unassigned tier is a tier that never gets made.' })
          ]));
        } else {
          box.appendChild(el('p', { class: 'arcp-tsheet__warn is-ok', role: 'status' }, [
            el('strong', { text: 'All tiers have a flavour ✓' }),
            el('span', { text: ' · the Planner can build the bake schedule.' })
          ]));
        }
      }
      box.appendChild(done);
    }

    /* the two names the rest of the file already calls after a write —
       both now mean "redraw the open tier sheet and the shelf" */
    function renderAssignSummary() { refreshOpenTierPicks(); }
    function refreshOpenTierPicks() {
      if (assignSheet && assignSheet.ldBody) tierSheetBody(assignSheet.ldBody, assignCombo, assignSheet.ldDone);
      renderShelf();
    }

    function openTierSheet(c) {
      var sh = makeSheet('bottom');
      assignSheet = sh; assignCombo = c;
      var fresh = activeB();
      sh.head.appendChild(el('span', { class: 'arcp-sheet__h2',
        text: 'Assign to a tier' }));
      var doneB = el('button', { class: 'arcp-sheet__done', type: 'button', text: 'Done' });
      doneB.addEventListener('click', function () { sh.close(); });
      sh.head.appendChild(doneB);
      sh.head.appendChild(el('span', { class: 'arcp-sheet__sub',
        text: (c ? c.name : 'This signature') + ' → ' + (((fresh && fresh.name) || '').trim() || 'the client') }));
      var box = el('div', { class: 'arcp-tsheet' });
      sh.ldBody = box;
      sh.ldDone = el('span', { class: 'arcp-tsheet__done', role: 'status' });
      sh.body.appendChild(box);
      tierSheetBody(box, c, sh.ldDone);
      sh.onClose = function () { assignSheet = null; assignCombo = null; };
      sh.open();
    }

    /* with no client file open the pill still reads ASSIGN TO A TIER and
       still works — it just asks WHICH cake first (design: "do not disable
       it and do not explain it in body copy") */
    function openClientSheet(after) {
      var sh = makeSheet('bottom');
      sh.head.appendChild(el('span', { class: 'arcp-sheet__h2', text: 'Which cake?' }));
      var doneB = el('button', { class: 'arcp-sheet__done', type: 'button', text: 'Done' });
      doneB.addEventListener('click', function () { sh.close(); });
      sh.head.appendChild(doneB);
      var list = el('div', { class: 'arcp-tsheet' });
      var store = (window.LdCakeFile && window.LdCakeFile.readStore) ? window.LdCakeFile.readStore() : { bookings: [] };
      var open = (store.bookings || []).filter(function (b) { return b.status !== 'archived'; });
      if (!open.length) {
        list.appendChild(el('p', { class: 'arcp-tsheet__none',
          text: 'No client files yet. Start one in the Planner and the signature drops straight onto a tier.' }));
        list.appendChild(el('a', { class: 'arcp-tsheet__link', href: '/pages/planner', text: 'Open the Planner →' }));
      }
      open.forEach(function (b) {
        var row = el('button', { class: 'arcp-trow__pick', type: 'button' }, [
          el('span', { class: 'arcp-trow__body' }, [
            el('span', { class: 'arcp-trow__t', text: (b.name || '').trim() || 'Untitled cake' }),
            el('span', { class: 'arcp-trow__s', text: (b.date || 'no date') + ' · ' + ((b.tierSpec || []).length || b.tiers || 0) + ' tiers' })
          ]),
          el('span', { class: 'arcp-tick', 'aria-hidden': 'true' })
        ]);
        row.addEventListener('click', function () {
          window.LdCakeFile.setActiveBooking(b.id, 'recipes');
          sh.close();
          if (after) after();
        });
        list.appendChild(el('div', { class: 'arcp-trow' }, [row]));
      });
      sh.body.appendChild(list);
      sh.open();
    }

    function assignFlow(c) {
      if (activeB()) { openTierSheet(c); return; }
      openClientSheet(function () { openTierSheet(c); });
    }

    /* ---------- the shelf card (Screen 1 · 1.2) ---------- */
    function comboLines(c) {
      var comps = (c.components || []).map(function (k) { return k.label || ''; });
      var out = [];
      var n = Math.min(comps.length, 4);
      for (var i = 0; i < n; i++) out.push({ t: comps[i], dim: false });
      /* empty slots read as an em dash, never as a shorter card */
      while (out.length < 4) out.push({ t: '—', dim: true });
      if (comps.length > 4) out.push({ t: '+' + (comps.length - 4) + ' more', dim: true });
      return out;
    }
    function comboCard(c, isMine) {
      var card = el('div', { class: 'arcp-scard' + (isMine ? '' : ' arcp-scard--studio') });
      var headKids = [];
      if (!isMine) headKids.push(el('span', { class: 'arcp-scard__eyebrow', text: 'STUDIO SIGNATURE' }));
      headKids.push(el('span', { class: 'arcp-scard__name', text: c.name }));
      headKids.push(el('span', { class: 'arcp-scard__rule', 'aria-hidden': 'true' }));
      var head = el('div', { class: 'arcp-scard__head' }, headKids);
      if (isMine) {
        /* replaces the always-on Edit / Delete text links */
        var more = el('button', { class: 'arcp-scard__more', type: 'button',
          'aria-label': 'More for ' + c.name, title: 'Edit, duplicate or delete' }, [
            el('span', { 'aria-hidden': 'true', text: '⋯' })
          ]);
        more.addEventListener('click', function (ev) { ev.stopPropagation(); openComboMenu(c); });
        head.appendChild(more);
      }
      card.appendChild(head);
      var lines = el('div', { class: 'arcp-scard__lines' });
      comboLines(c).forEach(function (l) {
        lines.appendChild(el('span', { class: 'arcp-scard__line' + (l.dim ? ' is-dim' : ''), text: l.t }));
      });
      card.appendChild(lines);
      var pill = el('button', { class: 'arcp-scard__pill', type: 'button',
        text: isMine ? 'ASSIGN TO A TIER' : 'ADD TO MY COMBOS' });
      pill.addEventListener('click', function () {
        if (isMine) { assignFlow(c); return; }
        /* r202 (Mariya, 2026-09-02): "the studio signatures should only be
           using the studio recipes, and those studio recipes should be
           added to a library the moment a signature combo is added."
           So: every studio (or sample) recipe the signature references is
           COPIED into her recipe box right here, once - the copy carries
           `from: <studio id>` so a second signature sharing the recipe
           reuses the same copy - and the combo's components point at the
           copies. Her own retyped recipes are never substituted in. A
           recipe that is not on this page (Academy-only data on a Pro
           page) keeps its studio link, unresolved but intact. */
        var comps = JSON.parse(JSON.stringify(c.components || []));
        var added = 0;
        comps.forEach(function (k) {
          if (!k.recipeId || mineById(k.recipeId)) return;
          var r = recipeById(k.recipeId);
          if (!r) return;
          var have = null;
          for (var mi = 0; mi < mine.items.length; mi++) {
            if (mine.items[mi].from === r.id) { have = mine.items[mi]; break; }
          }
          if (!have) {
            if (mine.items.length >= MINE_MAX) return;   /* the box is full: keep the studio link */
            have = { id: mineId(), title: r.title || 'Studio recipe', category: r.category || '',
              ingredients: JSON.parse(JSON.stringify(r.ingredients || [])),
              method: (r.method || []).slice(), from: r.id };
            if (r.variation) have.variation = r.variation;
            if (r.yieldNote) have.yieldNote = r.yieldNote;
            var yg = +(r.yieldG != null ? r.yieldG : r.yieldGrams);
            if (yg > 0) have.yieldG = yg;
            mine.items.push(have);
            added++;
          }
          k.recipeId = 'mine:' + have.id;
        });
        if (added) writeMine();
        MYC.push({ id: newComboId(), name: c.name, description: c.description || '',
          components: comps, fromStudio: c.id });
        saveMyc();
        renderShelf();
        if (added) { try { renderLibrary(); } catch (eM) { } }
      });
      card.appendChild(el('div', { class: 'arcp-scard__act' }, [pill]));
      return card;
    }

    function openComboMenu(c) {
      var sh = makeSheet('bottom');
      sh.panel.classList.add('arcp-sheet__panel--menu');
      sh.head.appendChild(el('span', { class: 'arcp-sheet__h2', text: c.name }));
      var doneB = el('button', { class: 'arcp-sheet__done', type: 'button', text: 'Done' });
      doneB.addEventListener('click', function () { sh.close(); });
      sh.head.appendChild(doneB);
      function item(label, cls, fn) {
        var b = el('button', { class: 'arcp-menuitem' + (cls ? ' ' + cls : ''), type: 'button', text: label });
        b.addEventListener('click', fn);
        return b;
      }
      sh.body.appendChild(item('Edit', '', function () { sh.close(); openBuilder(c); }));
      sh.body.appendChild(item('Duplicate', '', function () {
        MYC.push({ id: newComboId(), name: c.name + ' (copy)', description: c.description || '',
          components: JSON.parse(JSON.stringify(c.components || [])), fromStudio: c.fromStudio });
        saveMyc(); sh.close(); renderShelf();
      }));
      sh.body.appendChild(item('Delete', 'is-del', function () {
        if (!window.confirm('Delete “' + (c.name || 'this signature') + '” from your combos? Cakes already using it keep their saved copy.')) return;
        for (var di = 0; di < MYC.length; di++) if (MYC[di].id === c.id) { MYC.splice(di, 1); break; }
        saveMyc(); sh.close(); renderShelf();
      }));
      sh.open();
    }

    /* ---------- the shelf itself ---------- */
    /* a ?booking= link (the pipeline bar's "Next: Flavours") activates that
       client here exactly like it does on every other tool page */
    if (window.LdCakeFile && window.LdCakeFile.resolveScope) { try { window.LdCakeFile.resolveScope(); } catch (e) { } }

    var buildBtn = el('button', { class: 'arcp-shelf__build', type: 'button', text: 'Build one' });
    cMount.appendChild(el('div', { class: 'arcp-shelf__head' }, [
      el('span', { class: 'arcp-shelf__lbl', text: 'SIGNATURE COMBINATIONS' }),
      buildBtn
    ]));
    var track = el('div', { class: 'arcp-shelf', role: 'list', 'aria-label': 'Signature combinations' });
    cMount.appendChild(track);
    var dots = el('div', { class: 'arcp-dots', 'aria-hidden': 'true' });
    cMount.appendChild(dots);

    function clearEl(n) { while (n.firstChild) n.removeChild(n.firstChild); }

    function renderShelf() {
      clearEl(track);
      clearEl(dots);
      var cards = 0;
      if (!MYC.length && !COMBOS.length) {
        var invite = el('button', { class: 'arcp-scard arcp-scard--invite', type: 'button' }, [
          el('span', { class: 'arcp-scard__invitet', text: 'Build your first signature' }),
          el('span', { class: 'arcp-scard__invites', text: 'Name a pairing, then drop it on any tier.' })
        ]);
        invite.addEventListener('click', function () { openBuilder(null); });
        track.appendChild(invite);
      }
      MYC.forEach(function (c) { track.appendChild(comboCard(c, true)); cards++; });
      /* studio pairings live at the END of the same shelf (Combos v2:
         the island is an Academy benefit, so Pro/free never see this) */
      COMBOS.forEach(function (c) { track.appendChild(comboCard(c, false)); cards++; });
      var peek = el('span', { class: 'arcp-shelf__peek', 'aria-hidden': 'true' });
      track.appendChild(peek);
      /* the dots are a position readout, not a carousel control */
      if (cards > 1) {
        for (var i = 0; i < cards; i++) {
          dots.appendChild(el('span', { class: 'arcp-dot' + (i === 0 ? ' is-on' : '') }));
        }
      }
      /* the trailing dashed block only earns its place when the shelf
         really does continue past the edge (scrollWidth forces the layout
         it needs, so this reads true straight away) */
      peek.hidden = track.scrollWidth <= track.clientWidth + 8;
    }
    var dotRaf = 0;
    track.addEventListener('scroll', function () {
      if (dotRaf) return;
      dotRaf = requestAnimationFrame(function () {
        dotRaf = 0;
        var kids = dots.children;
        if (!kids.length) return;
        var card = track.querySelector('.arcp-scard');
        if (!card) return;
        var step = card.offsetWidth + 12;
        var idx = Math.max(0, Math.min(kids.length - 1, Math.round(track.scrollLeft / step)));
        for (var i = 0; i < kids.length; i++) kids[i].classList.toggle('is-on', i === idx);
      });
    });

    function mineById(id) {
      var m = (readMine().items || []);
      for (var i = 0; i < m.length; i++) if ('mine:' + m[i].id === id) return m[i];
      return null;
    }
    /* r133 (Mariya: "I don't see any of the ones from the Studio Academy
       recipes in these drop downs"). A signature is most often studio
       components — Vanilla montée, Sour cherry jelly — so the builder has
       to offer them. Academy only: the same gate that decides whether the
       studio library renders at all. */
    function studioRecipes() {
      return (IS_ACADEMY && DATA && DATA.recipes) ? DATA.recipes : [];
    }
    /* r177: samples are PUBLIC by design and ship as a trimmed island to
       every tier, so every tier's picker can offer them. */
    function sampleRecipes() { return SAMPLES; }
    function recipeById(id) {
      if (!id) return null;
      var m = mineById(id);
      if (m) return m;
      var lib = studioRecipes();
      for (var i = 0; i < lib.length; i++) if (lib[i].id === id) return lib[i];
      var sm = sampleRecipes();
      for (var j = 0; j < sm.length; j++) if (sm[j].id === id) return sm[j];
      return null;
    }

    /* ============================================================
       THE BUILDER (Screens 2 & 4) — named layer slots, no dropdowns.
       The stored shape is UNCHANGED: components stay
       {label, category, recipeId?} in slot order, because that is what
       syncComboComponents() and the Planner read. `role` rides along so
       an edit can put each component back on the slot it came from.
       ============================================================ */
    var ROLES = [
      { role: 'base',    label: 'BASE',             cats: ['bases'],                ph: 'Choose a cake',     title: 'Choose a base',              sph: 'Search bases' },
      { role: 'filling', label: 'FILLING',          cats: ['montees', 'cremeux'],   ph: 'Montée or crémeux', title: 'Choose a filling',  sph: 'Search fillings' },
      { role: 'fruit',   label: 'FRUIT OR CARAMEL', cats: ['jellies'],              ph: 'Optional',          title: 'Choose a fruit or caramel',  sph: 'Search fruit & caramel' },
      { role: 'finish',  label: 'FINISH',           cats: ['finishes'],             ph: 'Buttercream',       title: 'Choose a finish',            sph: 'Search finishes' }
    ];
    function roleOf(role) {
      for (var i = 0; i < ROLES.length; i++) if (ROLES[i].role === role) return ROLES[i];
      return { role: 'extra', label: 'EXTRA', cats: null, ph: 'Anything else', title: 'Choose a component', sph: 'Search recipes' };
    }
    /* an existing combo maps back onto the four named slots by category;
       anything left over becomes an EXTRA slot, so nothing is ever lost
       in a round trip through the builder */
    function slotsFrom(existing) {
      var slots = ROLES.map(function (R) { return { role: R.role, slotLabel: R.label, label: '', category: '', recipeId: null }; });
      if (!existing) return slots;
      var left = (existing.components || []).slice();
      slots.forEach(function (s) {
        var R = roleOf(s.role);
        for (var i = 0; i < left.length; i++) {
          var k = left[i];
          if (R.cats && R.cats.indexOf(k.category) === -1) continue;
          s.label = k.label || ''; s.category = k.category || ''; s.recipeId = k.recipeId || null;
          left.splice(i, 1);
          return;
        }
      });
      left.forEach(function (k) {
        slots.push({ role: 'extra', slotLabel: (k.role === 'extra' && k.slotLabel) || 'EXTRA',
          label: k.label || '', category: k.category || '', recipeId: k.recipeId || null });
      });
      return slots;
    }
    function filledSlots(slots) { return slots.filter(function (s) { return !!(s.label || '').trim(); }); }

    function openBuilder(existing) {
      var draft = {
        id: existing ? existing.id : null,
        name: existing ? (existing.name || '') : '',
        description: existing ? (existing.description || '') : '',
        fromStudio: existing ? existing.fromStudio : undefined,
        slots: slotsFrom(existing)
      };
      var sh = makeSheet('full');
      sh.panel.classList.add('arcp-sheet__panel--build');
      var saveTop = fullSheetHead(sh, existing ? 'EDIT SIGNATURE' : 'NEW SIGNATURE', 'Save', function () { doSave(false); });

      /* -- name -- */
      var nameI = el('input', { class: 'arcp-bname', type: 'text', maxlength: '40',
        placeholder: 'Pistachio Rose', 'aria-label': 'Signature name' });
      nameI.value = draft.name;
      nameI.addEventListener('input', function () {
        draft.name = nameI.value;
        nameI.classList.remove('is-bad');
        syncValid();
        drawPreview();
      });
      var nameBlock = el('div', { class: 'arcp-bfield' }, [
        el('span', { class: 'arcp-beyebrow', text: 'NAME' }), nameI
      ]);

      /* -- layers -- */
      var layersEyebrow = el('span', { class: 'arcp-beyebrow' });
      var slotsBox = el('div', { class: 'arcp-slots' });
      var addLayer = el('button', { class: 'arcp-blink', type: 'button', text: '+ Another layer' });
      addLayer.addEventListener('click', function () {
        draft.slots.push({ role: 'extra', slotLabel: 'EXTRA', label: '', category: '', recipeId: null });
        drawSlots();
      });
      var layersBlock = el('div', { class: 'arcp-bfield' }, [layersEyebrow, slotsBox, addLayer]);

      /* -- preview (Screen 4) -- */
      var preview = el('div', { class: 'arcp-preview' });

      /* -- footer -- */
      var saveB = el('button', { class: 'arcp-bsave', type: 'button', text: 'SAVE SIGNATURE' });
      saveB.addEventListener('click', function () { doSave(false); });
      var saveAssign = el('button', { class: 'arcp-bsave arcp-bsave--alt', type: 'button', text: 'SAVE & ASSIGN TO A TIER' });
      saveAssign.addEventListener('click', function () { doSave(true); });
      var foot = el('div', { class: 'arcp-bfoot' }, [saveB]);
      if (activeB()) foot.appendChild(saveAssign);
      if (COMBOS.length && !existing) {
        var fromStudio = el('button', { class: 'arcp-bstudio', type: 'button', text: 'Start from a studio pairing instead' });
        fromStudio.addEventListener('click', function () {
          var pick = makeSheet('bottom');
          pick.head.appendChild(el('span', { class: 'arcp-sheet__h2', text: 'Studio pairings' }));
          var d2 = el('button', { class: 'arcp-sheet__done', type: 'button', text: 'Done' });
          d2.addEventListener('click', function () { pick.close(); });
          pick.head.appendChild(d2);
          COMBOS.forEach(function (c) {
            var b = el('button', { class: 'arcp-presult', type: 'button' }, [
              el('span', { class: 'arcp-presult__b' }, [
                el('span', { class: 'arcp-presult__t', text: c.name }),
                el('span', { class: 'arcp-presult__s', text: componentLine(c) })
              ]),
              el('span', { class: 'arcp-tick', 'aria-hidden': 'true' })
            ]);
            b.addEventListener('click', function () {
              draft.name = c.name; nameI.value = c.name;
              draft.slots = slotsFrom(c);
              pick.close(); drawSlots(); syncValid(); drawPreview();
            });
            pick.body.appendChild(b);
          });
          pick.open();
        });
        foot.appendChild(fromStudio);
      }

      sh.body.appendChild(nameBlock);
      sh.body.appendChild(layersBlock);
      sh.body.appendChild(preview);
      sh.body.appendChild(foot);

      function syncValid() {
        var ok = !!draft.name.trim() && draft.name.trim().length <= 40 && filledSlots(draft.slots).length >= 2;
        saveTop.classList.toggle('is-on', ok);
        saveB.classList.toggle('is-on', ok);
        return ok;
      }
      function drawPreview() {
        clearNode(preview);
        var fs = filledSlots(draft.slots);
        if (!fs.length) { preview.hidden = true; return; }
        preview.hidden = false;
        /* the stack is generated from the slots: the cake layer repeats and
           the fillings interleave between them */
        var bars = [];
        function has(role) { return draft.slots.some(function (s) { return s.role === role && (s.label || '').trim(); }); }
        if (has('finish')) bars.push(['finish', 9]);
        if (has('fruit')) bars.push(['fruit', 7]);
        draft.slots.forEach(function (s) {
          if (s.role === 'extra' && (s.label || '').trim()) bars.push(['extra', 5]);
        });
        if (has('base')) bars.push(['cake', 11]);
        if (has('filling')) bars.push(['filling', 7]);
        if (has('base')) bars.push(['cake', 11]);
        var stack = el('div', { class: 'arcp-stack', 'aria-hidden': 'true' });
        bars.forEach(function (b) {
          var bar = el('span', { class: 'arcp-stack__b arcp-stack__b--' + b[0] });
          bar.style.height = b[1] + 'px';
          stack.appendChild(bar);
        });
        var ings = 0;
        fs.forEach(function (s) {
          var r = s.recipeId ? recipeById(s.recipeId) : null;
          if (r && r.ingredients) ings += r.ingredients.length;
        });
        preview.appendChild(stack);
        preview.appendChild(el('div', { class: 'arcp-preview__b' }, [
          el('span', { class: 'arcp-preview__n', text: draft.name.trim() || 'Untitled signature' }),
          el('span', { class: 'arcp-preview__m', text: fs.length + ' component' + (fs.length === 1 ? '' : 's')
            + (ings ? ' · ' + ings + ' ingredients' : '') })
        ]));
      }
      function drawSlots() {
        clearNode(slotsBox);
        var fs = filledSlots(draft.slots).length;
        layersEyebrow.textContent = 'THE LAYERS' + (fs ? ' · ' + fs : '');
        draft.slots.forEach(function (s, idx) {
          var R = roleOf(s.role);
          var filled = !!(s.label || '').trim();
          var row = el('div', { class: 'arcp-slot arcp-slot--' + s.role + (filled ? ' is-filled' : '') });
          row.appendChild(el('span', { class: 'arcp-slot__sw', 'aria-hidden': 'true' }));
          var lbl = el('span', { class: 'arcp-slot__lbl', text: s.slotLabel || R.label });
          if (s.role === 'extra') {
            /* the free-form slot's own label is the baker's to pick */
            lbl = el('input', { class: 'arcp-slot__lblin', type: 'text', maxlength: '18',
              value: s.slotLabel || 'EXTRA', 'aria-label': 'Layer label' });
            lbl.addEventListener('input', function () { s.slotLabel = lbl.value.toUpperCase(); });
            lbl.addEventListener('click', function (ev) { ev.stopPropagation(); });
          }
          var open = el('button', { class: 'arcp-slot__open', type: 'button',
            'aria-label': (s.slotLabel || R.label) + ' · ' + (filled ? s.label : 'choose a recipe') }, [
              el('span', { class: 'arcp-slot__val' + (filled ? '' : ' is-ph'), text: filled ? s.label : R.ph })
            ]);
          open.addEventListener('click', function () {
            openPicker(s, function () { drawSlots(); syncValid(); drawPreview(); });
          });
          var body = el('span', { class: 'arcp-slot__body' }, [lbl, open]);
          row.appendChild(body);
          if (filled) {
            /* r202 (Mariya, 2026-09-02: "I can't remove or delete a
               component"). A filled slot had a reorder grip and nothing
               else - the picker only ever assigns, so a layer was permanent
               for the life of the draft. A named slot clears back to its
               placeholder; an extra slot leaves entirely. The two-layer
               minimum is still enforced at save. */
            var rm = el('button', { class: 'arcp-slot__rm', type: 'button',
              'aria-label': 'Remove ' + s.label, title: 'Remove this layer' }, [
                el('span', { 'aria-hidden': 'true', text: '×' })
              ]);
            rm.addEventListener('click', function (ev) {
              ev.stopPropagation();
              if (s.role === 'extra') draft.slots.splice(idx, 1);
              else { s.label = ''; s.category = ''; s.recipeId = null; }
              drawSlots(); syncValid(); drawPreview();
            });
            row.appendChild(rm);
            var grip = el('button', { class: 'arcp-slot__grip', type: 'button',
              'aria-label': 'Reorder ' + s.label, title: 'Drag to reorder' }, [
                el('span', { 'aria-hidden': 'true', text: '⇅' })
              ]);
            bindDrag(grip, row, idx);
            row.appendChild(grip);
          } else {
            row.appendChild(el('span', { class: 'arcp-slot__plus', 'aria-hidden': 'true', text: '+' }));
          }
          slotsBox.appendChild(row);
        });
      }
      /* pointer-drag reorder: the label follows the row, because the label
         IS part of the layer, not a fixed position in the list */
      function bindDrag(grip, row, idx) {
        grip.addEventListener('pointerdown', function (ev) {
          ev.preventDefault();
          var startY = ev.clientY, cur = idx;
          var h = row.offsetHeight + 10;
          row.classList.add('is-dragging');
          try { grip.setPointerCapture(ev.pointerId); } catch (e) { }
          function move(e2) {
            var dy = e2.clientY - startY;
            var steps = Math.round(dy / h);
            var want = Math.max(0, Math.min(draft.slots.length - 1, idx + steps));
            if (want === cur) { row.style.transform = 'translateY(' + (dy - (cur - idx) * h) + 'px)'; return; }
            var moved = draft.slots.splice(cur, 1)[0];
            draft.slots.splice(want, 0, moved);
            cur = want;
            drawSlots();
          }
          function up() {
            row.classList.remove('is-dragging');
            row.style.transform = '';
            document.removeEventListener('pointermove', move);
            document.removeEventListener('pointerup', up);
            drawSlots(); drawPreview();
          }
          document.addEventListener('pointermove', move);
          document.addEventListener('pointerup', up);
        });
      }

      /* ---------- the picker sheet (Screen 3) ---------- */
      function openPicker(slot, after) {
        var R = roleOf(slot.role);
        var src = 'mine';          /* 'mine' = mine first, then studio */
        var allCats = !R.cats;
        var q = '';
        var pk = makeSheet('bottom');
        pk.panel.classList.add('arcp-sheet__panel--pick');
        pk.head.appendChild(el('span', { class: 'arcp-sheet__h2', text: R.title }));
        var doneB = el('button', { class: 'arcp-sheet__done', type: 'button', text: 'Done' });
        doneB.addEventListener('click', function () { pk.close(); });
        pk.head.appendChild(doneB);
        var sIn = el('input', { class: 'arcp-psearch', type: 'search', placeholder: R.sph,
          'aria-label': R.title });
        sIn.addEventListener('input', function () { q = sIn.value.trim().toLowerCase(); draw(); });
        pk.head.appendChild(el('div', { class: 'arcp-psearchwrap' }, [
          el('span', { class: 'arcp-searchwrap__g', 'aria-hidden': 'true' }), sIn
        ]));
        var chips = el('div', { class: 'arcp-pchips' });
        pk.head.appendChild(chips);
        var results = el('div', { class: 'arcp-presults' });
        pk.body.appendChild(results);

        function chip(label, on, fn, extraCls) {
          var b = el('button', { class: 'arcp-pchip' + (on ? ' is-on' : '') + (extraCls ? ' ' + extraCls : ''),
            type: 'button', text: label, 'aria-pressed': on ? 'true' : 'false' });
          b.addEventListener('click', fn);
          return b;
        }
        function drawChips() {
          clearNode(chips);
          var hasStudio = studioRecipes().length || sampleRecipes().length;
          chips.appendChild(chip('MINE', src === 'mine', function () { src = 'mine'; drawChips(); draw(); }));
          if (hasStudio) chips.appendChild(chip('STUDIO', src === 'studio', function () { src = 'studio'; drawChips(); draw(); }));
          if (R.cats) chips.appendChild(chip('ALL RECIPES', allCats, function () { allCats = !allCats; drawChips(); draw(); }, 'arcp-pchip--all'));
        }
        function inScope(r) {
          if (allCats || !R.cats) return true;
          return R.cats.indexOf(r.category) !== -1;
        }
        function hit(r) {
          if (!q) return true;
          var hay = ((r.title || '') + ' ' + (r.variation || '') + ' ' +
            (r.ingredients || []).map(function (i) { return i.item; }).join(' ')).toLowerCase();
          return hay.indexOf(q) !== -1;
        }
        function resultRow(r, id) {
          var on = slot.recipeId === id;
          var row = el('button', { class: 'arcp-presult' + (on ? ' is-on' : ''), type: 'button',
            'aria-pressed': on ? 'true' : 'false' }, [
            el('span', { class: 'arcp-presult__b' }, [
              el('span', { class: 'arcp-presult__t', text: (r.title || 'Recipe') + (r.variation ? ' · ' + r.variation : '') }),
              el('span', { class: 'arcp-presult__s', text: [shortYield(r.yieldNote),
                (r.ingredients || []).length + ' ingredient' + ((r.ingredients || []).length === 1 ? '' : 's')]
                .filter(Boolean).join(' · ') })
            ]),
            el('span', { class: 'arcp-tick' + (on ? ' is-on' : ''), 'aria-hidden': 'true' })
          ]);
          row.addEventListener('click', function () {
            slot.recipeId = id;
            slot.label = r.title || 'Recipe';
            slot.category = r.category || slot.category || (R.cats && R.cats[0]) || 'bases';
            draw();
            setTimeout(function () { pk.close(); if (after) after(); }, 160);
          });
          return row;
        }
        function draw() {
          clearNode(results);
          var mineR = (readMine().items || []).filter(function (r) { return inScope(r) && hit(r); });
          var sampR = sampleRecipes().filter(function (r) { return inScope(r) && hit(r); });
          var studR = studioRecipes().filter(function (r) { return inScope(r) && hit(r); });
          var n = 0;
          if (src === 'mine') {
            mineR.forEach(function (r) { results.appendChild(resultRow(r, 'mine:' + r.id)); n++; });
          }
          if (sampR.length) {
            results.appendChild(goldDivider('LAYER’D FREE SAMPLE'));
            sampR.forEach(function (r) { results.appendChild(resultRow(r, r.id)); n++; });
          }
          if (studR.length) {
            /* studio recipes always sort after the baker's own */
            results.appendChild(goldDivider('STUDIO LIBRARY'));
            studR.forEach(function (r) { results.appendChild(resultRow(r, r.id)); n++; });
          }
          if (!n) {
            var line = el('p', { class: 'arcp-pempty' });
            if (q) {
              line.appendChild(el('span', { text: 'No match · ' }));
              var add = el('button', { class: 'arcp-pempty__add', type: 'button', text: 'add it as a new recipe' });
              add.addEventListener('click', function () {
                var qq = sIn.value.trim();
                pk.close();
                openAddSheet(qq);
              });
              line.appendChild(add);
            } else if (src === 'studio') {
              line.appendChild(el('span', { text: 'Nothing in the studio library for this layer' }));
              if (R.cats && !allCats) line.appendChild(el('span', { text: ' · try ALL RECIPES.' }));
            } else {
              line.appendChild(el('span', { text: 'Nothing saved for this layer yet · ' }));
              var add2 = el('button', { class: 'arcp-pempty__add', type: 'button', text: 'add a recipe' });
              add2.addEventListener('click', function () { pk.close(); openAddSheet(''); });
              line.appendChild(add2);
            }
            results.appendChild(line);
          }
        }
        drawChips();
        draw();
        pk.open();
      }

      var err = el('p', { class: 'arcp-berr', role: 'alert' });
      sh.body.insertBefore(err, foot);
      function doSave(thenAssign) {
        /* no alert dialog: the name underline and the first empty slot
           carry the failure (design §Validation) */
        err.textContent = '';
        var nm = draft.name.trim();
        if (!nm || nm.length > 40) {
          nameI.classList.add('is-bad');
          err.textContent = nm ? 'Keep the name to 40 characters.' : 'Give the signature a name.';
          try { nameI.focus({ preventScroll: true }); } catch (e) { }
          return;
        }
        var fs = filledSlots(draft.slots);
        if (fs.length < 2) {
          var bad = slotsBox.querySelector('.arcp-slot:not(.is-filled)');
          if (bad) bad.classList.add('is-bad');
          err.textContent = 'A signature needs at least two layers.';
          return;
        }
        var comps = fs.map(function (s) {
          var o = { label: s.label, category: s.category || 'bases', role: s.role };
          if (s.recipeId) o.recipeId = s.recipeId;
          if (s.role === 'extra' && s.slotLabel) o.slotLabel = s.slotLabel;
          return o;
        });
        var saved;
        if (draft.id) {
          /* the id stays stable so tier assignments keep resolving */
          for (var i = 0; i < MYC.length; i++) {
            if (MYC[i].id === draft.id) {
              MYC[i] = { id: draft.id, name: nm, description: draft.description || '',
                components: comps, fromStudio: draft.fromStudio };
              saved = MYC[i];
              break;
            }
          }
        } else {
          saved = { id: newComboId(), name: nm, description: '', components: comps };
          MYC.push(saved);
        }
        saveMyc();
        sh.close();
        renderShelf();
        if (thenAssign && saved) assignFlow(saved);
      }

      drawSlots();
      syncValid();
      drawPreview();
      sh.open();
      try { nameI.focus({ preventScroll: true }); } catch (e) { }
    }

    buildBtn.addEventListener('click', function () { openBuilder(null); });
    renderShelf();
    /* arriving via #arcpCombos: the section renders after page JS, so the
       browser's own anchor jump misses it — do it ourselves (deferred past
       the pipebar insert, instant fallback if smooth silently no-ops) */
    if (location.hash === '#arcpCombos') {
      setTimeout(function () { ldNav(cMount); }, 160);
    }
  })();

  mount.appendChild(buildMineSection());
})();
